import fetchIntercept from "fetch-intercept";

fetchIntercept.register({
  request: function (url, config) {
    // Modify the url or config here
    if (localStorage.getItem("token") !== null)
      return [
        url,
        {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "TimeZone-Offset": `${new Date().getTimezoneOffset()}`,
            InstitutionAccess: localStorage.getItem("institutionId") ?? "",
          },
        },
      ];
    else return [url, config];
  },

  requestError: function (error) {
    // Called when an error occured during another 'request' interceptor call
    console.log(error);
    return Promise.reject(error);
  },

  response: function (response) {
    // // Modify the reponse object
    if (response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }

    if (response.status === 403) {
      console.log("Forbidden");
    }

    return response;
  },

  responseError: function (error) {
    // Handle an fetch error
    console.log(error);
    return Promise.reject(error);
  },
});


//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApplicationUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginDto | undefined): Promise<LoginResultDto> {
        let url_ = this.baseUrl + "/api/ApplicationUser/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApplicationUser/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    applicationUser(): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/ApplicationUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplicationUser(_response);
        });
    }

    protected processApplicationUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: ApplicationUserDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApplicationUser/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ClassroomApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<ClassroomDto[]> {
        let url_ = this.baseUrl + "/api/Classroom/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ClassroomDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassroomDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassroomDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getById(classroomId: string): Promise<ClassroomDto> {
        let url_ = this.baseUrl + "/api/Classroom/GetById/{classroomId}";
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ClassroomDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassroomDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassroomDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ClassroomDto | undefined): Promise<ClassroomDto> {
        let url_ = this.baseUrl + "/api/Classroom/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ClassroomDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassroomDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassroomDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ClassroomDto | undefined): Promise<ClassroomDto> {
        let url_ = this.baseUrl + "/api/Classroom/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ClassroomDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassroomDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassroomDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(classroomId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Classroom/Delete/{classroomId}";
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTeachers(classroomId: string, accademicYearId: string): Promise<TeacherClassroomDto[]> {
        let url_ = this.baseUrl + "/api/Classroom/GetTeachers/{classroomId}/{accademicYearId}";
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeachers(_response);
        });
    }

    protected processGetTeachers(response: Response): Promise<TeacherClassroomDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeacherClassroomDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeacherClassroomDto[]>(null as any);
    }
}

export class ClassScheduleApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    classroom(classroomId: string, accademicYearId: string): Promise<ClassScheduleDto[]> {
        let url_ = this.baseUrl + "/api/ClassSchedule/Classroom/{classroomId}/{accademicYearId}";
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClassroom(_response);
        });
    }

    protected processClassroom(response: Response): Promise<ClassScheduleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassScheduleDto[]>(null as any);
    }

    /**
     * @return Success
     */
    teacher(teacherId: string, accademicYearId: string): Promise<ClassScheduleDto[]> {
        let url_ = this.baseUrl + "/api/ClassSchedule/Teacher/{teacherId}/{accademicYearId}";
        if (teacherId === undefined || teacherId === null)
            throw new globalThis.Error("The parameter 'teacherId' must be defined.");
        url_ = url_.replace("{teacherId}", encodeURIComponent("" + teacherId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeacher(_response);
        });
    }

    protected processTeacher(response: Response): Promise<ClassScheduleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassScheduleDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getById(classScheduleId: string): Promise<ClassScheduleDto> {
        let url_ = this.baseUrl + "/api/ClassSchedule/GetById/{classScheduleId}";
        if (classScheduleId === undefined || classScheduleId === null)
            throw new globalThis.Error("The parameter 'classScheduleId' must be defined.");
        url_ = url_.replace("{classScheduleId}", encodeURIComponent("" + classScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ClassScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassScheduleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ClassScheduleDto | undefined): Promise<ClassScheduleDto> {
        let url_ = this.baseUrl + "/api/ClassSchedule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ClassScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassScheduleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ClassScheduleDto | undefined): Promise<ClassScheduleDto> {
        let url_ = this.baseUrl + "/api/ClassSchedule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ClassScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassScheduleDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(classScheduleId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/ClassSchedule/Delete/{classScheduleId}";
        if (classScheduleId === undefined || classScheduleId === null)
            throw new globalThis.Error("The parameter 'classScheduleId' must be defined.");
        url_ = url_.replace("{classScheduleId}", encodeURIComponent("" + classScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExamApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getById(examId: string): Promise<ExamDto> {
        let url_ = this.baseUrl + "/api/Exam/GetById/{examId}";
        if (examId === undefined || examId === null)
            throw new globalThis.Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ExamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDto>(null as any);
    }

    /**
     * @return Success
     */
    classroom(classroomId: string, accademicYearId: string): Promise<ExamDto[]> {
        let url_ = this.baseUrl + "/api/Exam/Classroom/{classroomId}/{accademicYearId}";
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClassroom(_response);
        });
    }

    protected processClassroom(response: Response): Promise<ExamDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExamDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDto[]>(null as any);
    }

    /**
     * @return Success
     */
    student(studentId: string, accademicYearId: string): Promise<StudentExamDto[]> {
        let url_ = this.baseUrl + "/api/Exam/Student/{studentId}/{accademicYearId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent(_response);
        });
    }

    protected processStudent(response: Response): Promise<StudentExamDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudentExamDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentExamDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ExamDto | undefined): Promise<ExamDto> {
        let url_ = this.baseUrl + "/api/Exam/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ExamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ExamDto | undefined): Promise<ExamDto> {
        let url_ = this.baseUrl + "/api/Exam/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ExamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(examId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Exam/Delete/{examId}";
        if (examId === undefined || examId === null)
            throw new globalThis.Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExamGradeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    studentPath(studentPathId: string): Promise<ExamGradeDto[]> {
        let url_ = this.baseUrl + "/api/ExamGrade/StudentPath/{studentPathId}";
        if (studentPathId === undefined || studentPathId === null)
            throw new globalThis.Error("The parameter 'studentPathId' must be defined.");
        url_ = url_.replace("{studentPathId}", encodeURIComponent("" + studentPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudentPath(_response);
        });
    }

    protected processStudentPath(response: Response): Promise<ExamGradeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExamGradeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamGradeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    teacher(teacherId: string): Promise<ExamGradeDto[]> {
        let url_ = this.baseUrl + "/api/ExamGrade/Teacher/{teacherId}";
        if (teacherId === undefined || teacherId === null)
            throw new globalThis.Error("The parameter 'teacherId' must be defined.");
        url_ = url_.replace("{teacherId}", encodeURIComponent("" + teacherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeacher(_response);
        });
    }

    protected processTeacher(response: Response): Promise<ExamGradeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExamGradeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamGradeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    exam(examId: string): Promise<ExamGradeDto[]> {
        let url_ = this.baseUrl + "/api/ExamGrade/Exam/{examId}";
        if (examId === undefined || examId === null)
            throw new globalThis.Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExam(_response);
        });
    }

    protected processExam(response: Response): Promise<ExamGradeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExamGradeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamGradeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getById(examGradeId: string): Promise<ExamGradeDto> {
        let url_ = this.baseUrl + "/api/ExamGrade/GetById/{examGradeId}";
        if (examGradeId === undefined || examGradeId === null)
            throw new globalThis.Error("The parameter 'examGradeId' must be defined.");
        url_ = url_.replace("{examGradeId}", encodeURIComponent("" + examGradeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ExamGradeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamGradeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamGradeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ExamGradeDto | undefined): Promise<ExamGradeDto> {
        let url_ = this.baseUrl + "/api/ExamGrade/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ExamGradeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamGradeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamGradeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ExamGradeDto | undefined): Promise<ExamGradeDto> {
        let url_ = this.baseUrl + "/api/ExamGrade/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ExamGradeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamGradeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamGradeDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(examGradeId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/ExamGrade/Delete/{examGradeId}";
        if (examGradeId === undefined || examGradeId === null)
            throw new globalThis.Error("The parameter 'examGradeId' must be defined.");
        url_ = url_.replace("{examGradeId}", encodeURIComponent("" + examGradeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExpenseApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    allFurnisher(onlyActive: boolean): Promise<FurnisherDto[]> {
        let url_ = this.baseUrl + "/api/Expense/AllFurnisher/{onlyActive}";
        if (onlyActive === undefined || onlyActive === null)
            throw new globalThis.Error("The parameter 'onlyActive' must be defined.");
        url_ = url_.replace("{onlyActive}", encodeURIComponent("" + onlyActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAllFurnisher(_response);
        });
    }

    protected processAllFurnisher(response: Response): Promise<FurnisherDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FurnisherDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FurnisherDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ExpenseDto | undefined): Promise<ExpenseDto> {
        let url_ = this.baseUrl + "/api/Expense/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: Response): Promise<ExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    csv(body: ExpenseFilterDto | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Expense/Csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCsv(_response);
        });
    }

    protected processCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filter(body: ExpenseFilterDto | undefined): Promise<ExpenseDtoAmountPaginatedDto> {
        let url_ = this.baseUrl + "/api/Expense/Filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: Response): Promise<ExpenseDtoAmountPaginatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseDtoAmountPaginatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDtoAmountPaginatedDto>(null as any);
    }

    /**
     * @return Success
     */
    getById(expenseId: string): Promise<ExpenseDto> {
        let url_ = this.baseUrl + "/api/Expense/GetById/{expenseId}";
        if (expenseId === undefined || expenseId === null)
            throw new globalThis.Error("The parameter 'expenseId' must be defined.");
        url_ = url_.replace("{expenseId}", encodeURIComponent("" + expenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDto>(null as any);
    }

    /**
     * @return Success
     */
    expense(expenseId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Expense/{expenseId}";
        if (expenseId === undefined || expenseId === null)
            throw new globalThis.Error("The parameter 'expenseId' must be defined.");
        url_ = url_.replace("{expenseId}", encodeURIComponent("" + expenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpense(_response);
        });
    }

    protected processExpense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Promise<ExpenseDto[]> {
        let url_ = this.baseUrl + "/api/Expense/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ExpenseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDto[]>(null as any);
    }
}

export class FurnisherApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param onlyActive (optional) 
     * @return Success
     */
    furnisherGet(onlyActive: boolean | undefined): Promise<FurnisherDto[]> {
        let url_ = this.baseUrl + "/api/Furnisher?";
        if (onlyActive === null)
            throw new globalThis.Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFurnisherGet(_response);
        });
    }

    protected processFurnisherGet(response: Response): Promise<FurnisherDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FurnisherDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FurnisherDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnisherPost(body: FurnisherDto | undefined): Promise<FurnisherDto> {
        let url_ = this.baseUrl + "/api/Furnisher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFurnisherPost(_response);
        });
    }

    protected processFurnisherPost(response: Response): Promise<FurnisherDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FurnisherDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnisherPut(body: FurnisherDto | undefined): Promise<FurnisherDto> {
        let url_ = this.baseUrl + "/api/Furnisher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFurnisherPut(_response);
        });
    }

    protected processFurnisherPut(response: Response): Promise<FurnisherDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FurnisherDto>(null as any);
    }

    /**
     * @return Success
     */
    getById(furnisherId: string): Promise<FurnisherDto> {
        let url_ = this.baseUrl + "/api/Furnisher/GetById/{furnisherId}";
        if (furnisherId === undefined || furnisherId === null)
            throw new globalThis.Error("The parameter 'furnisherId' must be defined.");
        url_ = url_.replace("{furnisherId}", encodeURIComponent("" + furnisherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<FurnisherDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FurnisherDto>(null as any);
    }

    /**
     * @return Success
     */
    deleteById(furnisherId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Furnisher/DeleteById/{furnisherId}";
        if (furnisherId === undefined || furnisherId === null)
            throw new globalThis.Error("The parameter 'furnisherId' must be defined.");
        url_ = url_.replace("{furnisherId}", encodeURIComponent("" + furnisherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InscriptionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: InscriptionDto | undefined): Promise<InscriptionDto> {
        let url_ = this.baseUrl + "/api/Inscription/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: Response): Promise<InscriptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InscriptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InscriptionDto>(null as any);
    }

    /**
     * @return Success
     */
    studentPath(serviceType: ServiceType, studentPathId: string): Promise<InscriptionDto> {
        let url_ = this.baseUrl + "/api/Inscription/ServiceType/{serviceType}/StudentPath/{studentPathId}";
        if (serviceType === undefined || serviceType === null)
            throw new globalThis.Error("The parameter 'serviceType' must be defined.");
        url_ = url_.replace("{serviceType}", encodeURIComponent("" + serviceType));
        if (studentPathId === undefined || studentPathId === null)
            throw new globalThis.Error("The parameter 'studentPathId' must be defined.");
        url_ = url_.replace("{studentPathId}", encodeURIComponent("" + studentPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudentPath(_response);
        });
    }

    protected processStudentPath(response: Response): Promise<InscriptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InscriptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InscriptionDto>(null as any);
    }

    /**
     * @return Success
     */
    service(studentPathId: string, serviceId: string): Promise<InscriptionDto[]> {
        let url_ = this.baseUrl + "/api/Inscription/History/StudentPath/{studentPathId}/Service/{serviceId}";
        if (studentPathId === undefined || studentPathId === null)
            throw new globalThis.Error("The parameter 'studentPathId' must be defined.");
        url_ = url_.replace("{studentPathId}", encodeURIComponent("" + studentPathId));
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processService(_response);
        });
    }

    protected processService(response: Response): Promise<InscriptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InscriptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InscriptionDto[]>(null as any);
    }
}

export class InstitutionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    all(): Promise<Institution[]> {
        let url_ = this.baseUrl + "/api/Institution/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Institution[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Institution.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Institution[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(institutionId: string, body: InstitutionDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Institution/update/{institutionId}";
        if (institutionId === undefined || institutionId === null)
            throw new globalThis.Error("The parameter 'institutionId' must be defined.");
        url_ = url_.replace("{institutionId}", encodeURIComponent("" + institutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadLogo(institutionId: string, file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Institution/uploadLogo/{institutionId}";
        if (institutionId === undefined || institutionId === null)
            throw new globalThis.Error("The parameter 'institutionId' must be defined.");
        url_ = url_.replace("{institutionId}", encodeURIComponent("" + institutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadLogo(_response);
        });
    }

    protected processUploadLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadInstitutionImageogo(institutionId: string, file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Institution/uploadInstitutionImageogo/{institutionId}";
        if (institutionId === undefined || institutionId === null)
            throw new globalThis.Error("The parameter 'institutionId' must be defined.");
        url_ = url_.replace("{institutionId}", encodeURIComponent("" + institutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadInstitutionImageogo(_response);
        });
    }

    protected processUploadInstitutionImageogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSms(body: NotificationDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Notification/SendSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendSms(_response);
        });
    }

    protected processSendSms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSmsCustomRecipient(body: NotificationDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Notification/SendSmsCustomRecipient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendSmsCustomRecipient(_response);
        });
    }

    protected processSendSmsCustomRecipient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ParentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ParentCreationDto | undefined): Promise<ParentDto> {
        let url_ = this.baseUrl + "/api/Parent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ParentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(parentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Parent/Delete/{parentId}";
        if (parentId === undefined || parentId === null)
            throw new globalThis.Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    byId(parentId: string): Promise<ParentDto> {
        let url_ = this.baseUrl + "/api/Parent/ById/{parentId}";
        if (parentId === undefined || parentId === null)
            throw new globalThis.Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processById(_response);
        });
    }

    protected processById(response: Response): Promise<ParentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filter(body: ParentFilterDto | undefined): Promise<ParentDtoPaginatedDto> {
        let url_ = this.baseUrl + "/api/Parent/Filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: Response): Promise<ParentDtoPaginatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParentDtoPaginatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentDtoPaginatedDto>(null as any);
    }

    /**
     * @return Success
     */
    byStudentId(studentId: string): Promise<ParentDto[]> {
        let url_ = this.baseUrl + "/api/Parent/ByStudentId/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByStudentId(_response);
        });
    }

    protected processByStudentId(response: Response): Promise<ParentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ParentCreationDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Parent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PaymentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentPut(body: PaymentDto | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentPut(_response);
        });
    }

    protected processPaymentPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentPost(body: PaymentDto | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentPost(_response);
        });
    }

    protected processPaymentPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    paymentDelete(paymentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Payment/{paymentId}";
        if (paymentId === undefined || paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaymentDelete(_response);
        });
    }

    protected processPaymentDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    csv(body: PaymentFilterDto | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payment/Csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCsv(_response);
        });
    }

    protected processCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filter(body: PaymentFilterDto | undefined): Promise<PaymentDtoAmountPaginatedDto> {
        let url_ = this.baseUrl + "/api/Payment/Filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: Response): Promise<PaymentDtoAmountPaginatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentDtoAmountPaginatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentDtoAmountPaginatedDto>(null as any);
    }

    /**
     * @return Success
     */
    byId(paymentId: string): Promise<PaymentDto> {
        let url_ = this.baseUrl + "/api/Payment/ById/{paymentId}";
        if (paymentId === undefined || paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processById(_response);
        });
    }

    protected processById(response: Response): Promise<PaymentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentDto>(null as any);
    }

    /**
     * @return Success
     */
    all(): Promise<PaymentDto[]> {
        let url_ = this.baseUrl + "/api/Payment/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<PaymentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentDto[]>(null as any);
    }

    /**
     * @return Success
     */
    publicById(paymentId: string): Promise<PublicPaymentResultDto> {
        let url_ = this.baseUrl + "/api/Payment/PublicById/{paymentId}";
        if (paymentId === undefined || paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublicById(_response);
        });
    }

    protected processPublicById(response: Response): Promise<PublicPaymentResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicPaymentResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicPaymentResultDto>(null as any);
    }

    /**
     * @return Success
     */
    monthPaymentsByStudentPathId(studentPathId: string): Promise<StudentMonthlyPaymentSituationDto[]> {
        let url_ = this.baseUrl + "/api/Payment/MonthPaymentsByStudentPathId/{studentPathId}";
        if (studentPathId === undefined || studentPathId === null)
            throw new globalThis.Error("The parameter 'studentPathId' must be defined.");
        url_ = url_.replace("{studentPathId}", encodeURIComponent("" + studentPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMonthPaymentsByStudentPathId(_response);
        });
    }

    protected processMonthPaymentsByStudentPathId(response: Response): Promise<StudentMonthlyPaymentSituationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudentMonthlyPaymentSituationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentMonthlyPaymentSituationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    generatePdf(paymentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Payment/GeneratePdf/{paymentId}";
        if (paymentId === undefined || paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeneratePdf(_response);
        });
    }

    protected processGeneratePdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SchoolApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    accademicYears(): Promise<AccademicYearDto[]> {
        let url_ = this.baseUrl + "/api/School/AccademicYears";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccademicYears(_response);
        });
    }

    protected processAccademicYears(response: Response): Promise<AccademicYearDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccademicYearDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccademicYearDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editAccademicYear(body: AccademicYearDto | undefined): Promise<AccademicYearDto> {
        let url_ = this.baseUrl + "/api/School/EditAccademicYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditAccademicYear(_response);
        });
    }

    protected processEditAccademicYear(response: Response): Promise<AccademicYearDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccademicYearDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccademicYearDto>(null as any);
    }

    /**
     * @return Success
     */
    educations(): Promise<EducationDto[]> {
        let url_ = this.baseUrl + "/api/School/Educations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEducations(_response);
        });
    }

    protected processEducations(response: Response): Promise<EducationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    dashboard(accademicYearId: string): Promise<DashboardSchoolDto> {
        let url_ = this.baseUrl + "/api/School/Dashboard/{accademicYearId}";
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard(_response);
        });
    }

    protected processDashboard(response: Response): Promise<DashboardSchoolDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardSchoolDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSchoolDto>(null as any);
    }

    /**
     * @return Success
     */
    dashboardClassroom(accademicYearId: string, classroomId: string): Promise<DashboardEducationDto> {
        let url_ = this.baseUrl + "/api/School/DashboardClassroom/{accademicYearId}/{classroomId}";
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboardClassroom(_response);
        });
    }

    protected processDashboardClassroom(response: Response): Promise<DashboardEducationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardEducationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardEducationDto>(null as any);
    }

    /**
     * @return Success
     */
    dashboardEducation(accademicYearId: string, educationId: string): Promise<DashboardEducationDto> {
        let url_ = this.baseUrl + "/api/School/DashboardEducation/{accademicYearId}/{educationId}";
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        if (educationId === undefined || educationId === null)
            throw new globalThis.Error("The parameter 'educationId' must be defined.");
        url_ = url_.replace("{educationId}", encodeURIComponent("" + educationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboardEducation(_response);
        });
    }

    protected processDashboardEducation(response: Response): Promise<DashboardEducationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardEducationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardEducationDto>(null as any);
    }
}

export class ServiceApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    service(): Promise<ServiceDto[]> {
        let url_ = this.baseUrl + "/api/Service";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processService(_response);
        });
    }

    protected processService(response: Response): Promise<ServiceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceDto[]>(null as any);
    }
}

export class StatisticApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    payments(accademicYearId: string, statisticPeriod: StatisticPeriod): Promise<PaymentStatisticDto[]> {
        let url_ = this.baseUrl + "/api/Statistic/Payments/{accademicYearId}/{statisticPeriod}";
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        if (statisticPeriod === undefined || statisticPeriod === null)
            throw new globalThis.Error("The parameter 'statisticPeriod' must be defined.");
        url_ = url_.replace("{statisticPeriod}", encodeURIComponent("" + statisticPeriod));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPayments(_response);
        });
    }

    protected processPayments(response: Response): Promise<PaymentStatisticDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentStatisticDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentStatisticDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    incomeOutcome(body: StatisticFilterDto | undefined): Promise<DoubleChartDto[]> {
        let url_ = this.baseUrl + "/api/Statistic/IncomeOutcome";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIncomeOutcome(_response);
        });
    }

    protected processIncomeOutcome(response: Response): Promise<DoubleChartDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoubleChartDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoubleChartDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    periodExpenses(body: StatisticFilterDto | undefined): Promise<DoubleChartDto[]> {
        let url_ = this.baseUrl + "/api/Statistic/PeriodExpenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPeriodExpenses(_response);
        });
    }

    protected processPeriodExpenses(response: Response): Promise<DoubleChartDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoubleChartDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoubleChartDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    expensesByFurnisher(body: StatisticFilterDto | undefined): Promise<PieChartDto> {
        let url_ = this.baseUrl + "/api/Statistic/ExpensesByFurnisher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpensesByFurnisher(_response);
        });
    }

    protected processExpensesByFurnisher(response: Response): Promise<PieChartDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PieChartDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PieChartDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnisherExpenses(body: FurnisherExpenseFilterDto | undefined): Promise<FurnisherExpenseStatisticDto> {
        let url_ = this.baseUrl + "/api/Statistic/FurnisherExpenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFurnisherExpenses(_response);
        });
    }

    protected processFurnisherExpenses(response: Response): Promise<FurnisherExpenseStatisticDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnisherExpenseStatisticDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FurnisherExpenseStatisticDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    periodReporting(body: StatisticFilterDto | undefined): Promise<PeriodReportingDto> {
        let url_ = this.baseUrl + "/api/Statistic/PeriodReporting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPeriodReporting(_response);
        });
    }

    protected processPeriodReporting(response: Response): Promise<PeriodReportingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodReportingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeriodReportingDto>(null as any);
    }
}

export class StudentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: StudentUpdateDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Student/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: StudentCreationDto | undefined): Promise<StudentView> {
        let url_ = this.baseUrl + "/api/Student/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StudentView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentView.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentView>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filter(body: StudentFilterDto | undefined): Promise<StudentViewPaginatedDto> {
        let url_ = this.baseUrl + "/api/Student/Filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: Response): Promise<StudentViewPaginatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentViewPaginatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentViewPaginatedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    csv(body: StudentFilterDto | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Student/Csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCsv(_response);
        });
    }

    protected processCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    classroom(classroomId: string, accademicYearId: string): Promise<StudentView[]> {
        let url_ = this.baseUrl + "/api/Student/Classroom/{classroomId}/{accademicYearId}";
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClassroom(_response);
        });
    }

    protected processClassroom(response: Response): Promise<StudentView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudentView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentView[]>(null as any);
    }

    /**
     * @return Success
     */
    dashboard(studentPathId: string, accademicYearId: string): Promise<DashboardStudentDto> {
        let url_ = this.baseUrl + "/api/Student/Dashboard/{studentPathId}/{accademicYearId}";
        if (studentPathId === undefined || studentPathId === null)
            throw new globalThis.Error("The parameter 'studentPathId' must be defined.");
        url_ = url_.replace("{studentPathId}", encodeURIComponent("" + studentPathId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard(_response);
        });
    }

    protected processDashboard(response: Response): Promise<DashboardStudentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardStudentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardStudentDto>(null as any);
    }

    /**
     * @return Success
     */
    getByStudentIdAccademicYearId(studentId: string, accademicYearId: string): Promise<StudentView> {
        let url_ = this.baseUrl + "/api/Student/GetByStudentIdAccademicYearId/{studentId}/{accademicYearId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByStudentIdAccademicYearId(_response);
        });
    }

    protected processGetByStudentIdAccademicYearId(response: Response): Promise<StudentView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentView.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentView>(null as any);
    }

    /**
     * @return Success
     */
    getByStudentId(studentId: string): Promise<StudentView> {
        let url_ = this.baseUrl + "/api/Student/GetByStudentId/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByStudentId(_response);
        });
    }

    protected processGetByStudentId(response: Response): Promise<StudentView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentView.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentView>(null as any);
    }

    /**
     * @return Success
     */
    getByParentId(parentId: string): Promise<StudentView[]> {
        let url_ = this.baseUrl + "/api/Student/GetByParentId/{parentId}";
        if (parentId === undefined || parentId === null)
            throw new globalThis.Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByParentId(_response);
        });
    }

    protected processGetByParentId(response: Response): Promise<StudentView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudentView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentView[]>(null as any);
    }

    /**
     * @return Success
     */
    studentPathHistory(studentId: string): Promise<StudentPathDto[]> {
        let url_ = this.baseUrl + "/api/Student/StudentPathHistory/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudentPathHistory(_response);
        });
    }

    protected processStudentPathHistory(response: Response): Promise<StudentPathDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudentPathDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentPathDto[]>(null as any);
    }

    /**
     * @return Success
     */
    delete(studentId: string, checkP: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Student/Delete/{studentId}/{checkP}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (checkP === undefined || checkP === null)
            throw new globalThis.Error("The parameter 'checkP' must be defined.");
        url_ = url_.replace("{checkP}", encodeURIComponent("" + checkP));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StudentPathApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    newStudentPath(body: NewStudentPathDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StudentPath/NewStudentPath";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNewStudentPath(_response);
        });
    }

    protected processNewStudentPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: StudentPathUpdateDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StudentPath/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StudentPaymentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filter(body: FilterDto | undefined): Promise<StudentPaymentDtoPaginatedDto> {
        let url_ = this.baseUrl + "/api/StudentPayment/Filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: Response): Promise<StudentPaymentDtoPaginatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentPaymentDtoPaginatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentPaymentDtoPaginatedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filterByStudentPath(studentPathId: string, body: FilterDto | undefined): Promise<StudentPaymentDtoAmountPaginatedDto> {
        let url_ = this.baseUrl + "/api/StudentPayment/FilterByStudentPath/{studentPathId}";
        if (studentPathId === undefined || studentPathId === null)
            throw new globalThis.Error("The parameter 'studentPathId' must be defined.");
        url_ = url_.replace("{studentPathId}", encodeURIComponent("" + studentPathId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilterByStudentPath(_response);
        });
    }

    protected processFilterByStudentPath(response: Response): Promise<StudentPaymentDtoAmountPaginatedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentPaymentDtoAmountPaginatedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentPaymentDtoAmountPaginatedDto>(null as any);
    }
}

export class SubjectApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<SubjectDto[]> {
        let url_ = this.baseUrl + "/api/Subject/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SubjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getById(subjectId: string): Promise<SubjectDto> {
        let url_ = this.baseUrl + "/api/Subject/GetById/{subjectId}";
        if (subjectId === undefined || subjectId === null)
            throw new globalThis.Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<SubjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SubjectDto | undefined): Promise<SubjectDto> {
        let url_ = this.baseUrl + "/api/Subject/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SubjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: SubjectDto | undefined): Promise<SubjectDto> {
        let url_ = this.baseUrl + "/api/Subject/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<SubjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(subjectId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Subject/Delete/{subjectId}";
        if (subjectId === undefined || subjectId === null)
            throw new globalThis.Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TeacherApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param onlyActive (optional) 
     * @return Success
     */
    getAll(onlyActive: boolean | undefined): Promise<TeacherDto[]> {
        let url_ = this.baseUrl + "/api/Teacher/GetAll?";
        if (onlyActive === null)
            throw new globalThis.Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TeacherDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeacherDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeacherDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getById(teacherId: string): Promise<TeacherDto> {
        let url_ = this.baseUrl + "/api/Teacher/GetById/{teacherId}";
        if (teacherId === undefined || teacherId === null)
            throw new globalThis.Error("The parameter 'teacherId' must be defined.");
        url_ = url_.replace("{teacherId}", encodeURIComponent("" + teacherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<TeacherDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeacherDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeacherDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TeacherDto | undefined): Promise<TeacherDto> {
        let url_ = this.baseUrl + "/api/Teacher/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TeacherDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeacherDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeacherDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(teacherId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Teacher/Delete/{teacherId}";
        if (teacherId === undefined || teacherId === null)
            throw new globalThis.Error("The parameter 'teacherId' must be defined.");
        url_ = url_.replace("{teacherId}", encodeURIComponent("" + teacherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    classroomsGet(teacherId: string, accademicYearId: string): Promise<TeacherClassroomDto[]> {
        let url_ = this.baseUrl + "/api/Teacher/GetClassrooms/{teacherId}/Classrooms/{accademicYearId}";
        if (teacherId === undefined || teacherId === null)
            throw new globalThis.Error("The parameter 'teacherId' must be defined.");
        url_ = url_.replace("{teacherId}", encodeURIComponent("" + teacherId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClassroomsGet(_response);
        });
    }

    protected processClassroomsGet(response: Response): Promise<TeacherClassroomDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeacherClassroomDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeacherClassroomDto[]>(null as any);
    }

    /**
     * @return Success
     */
    classroomsPost(teacherId: string, classroomId: string, accademicYearId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Teacher/AssignClassroom/{teacherId}/Classrooms/{classroomId}/{accademicYearId}";
        if (teacherId === undefined || teacherId === null)
            throw new globalThis.Error("The parameter 'teacherId' must be defined.");
        url_ = url_.replace("{teacherId}", encodeURIComponent("" + teacherId));
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClassroomsPost(_response);
        });
    }

    protected processClassroomsPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    classroomsDelete(teacherId: string, classroomId: string, accademicYearId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Teacher/UnassignClassroom/{teacherId}/Classrooms/{classroomId}/{accademicYearId}";
        if (teacherId === undefined || teacherId === null)
            throw new globalThis.Error("The parameter 'teacherId' must be defined.");
        url_ = url_.replace("{teacherId}", encodeURIComponent("" + teacherId));
        if (classroomId === undefined || classroomId === null)
            throw new globalThis.Error("The parameter 'classroomId' must be defined.");
        url_ = url_.replace("{classroomId}", encodeURIComponent("" + classroomId));
        if (accademicYearId === undefined || accademicYearId === null)
            throw new globalThis.Error("The parameter 'accademicYearId' must be defined.");
        url_ = url_.replace("{accademicYearId}", encodeURIComponent("" + accademicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClassroomsDelete(_response);
        });
    }

    protected processClassroomsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserProfileApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    userProfile(): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/UserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserProfile(_response);
        });
    }

    protected processUserProfile(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export class AccademicYear implements IAccademicYear {
    accademicYearId?: string;
    institutionId?: string;
    startDate?: Date;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    hasTransport?: boolean;
    hasChildCare?: boolean;
    hasCanteen?: boolean;
    transportFees?: number;
    childCareFees?: number;
    canteenFees?: number;
    payments?: Payment[] | undefined;
    studentPaths?: StudentPath[] | undefined;
    teacherClassrooms?: TeacherClassroom[] | undefined;
    classSchedules?: ClassSchedule[] | undefined;
    exams?: Exam[] | undefined;

    constructor(data?: IAccademicYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.institutionId = _data["institutionId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.inscriptionFees = _data["inscriptionFees"];
            this.monthlyFees = _data["monthlyFees"];
            this.hasTransport = _data["hasTransport"];
            this.hasChildCare = _data["hasChildCare"];
            this.hasCanteen = _data["hasCanteen"];
            this.transportFees = _data["transportFees"];
            this.childCareFees = _data["childCareFees"];
            this.canteenFees = _data["canteenFees"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(Payment.fromJS(item));
            }
            if (Array.isArray(_data["studentPaths"])) {
                this.studentPaths = [] as any;
                for (let item of _data["studentPaths"])
                    this.studentPaths!.push(StudentPath.fromJS(item));
            }
            if (Array.isArray(_data["teacherClassrooms"])) {
                this.teacherClassrooms = [] as any;
                for (let item of _data["teacherClassrooms"])
                    this.teacherClassrooms!.push(TeacherClassroom.fromJS(item));
            }
            if (Array.isArray(_data["classSchedules"])) {
                this.classSchedules = [] as any;
                for (let item of _data["classSchedules"])
                    this.classSchedules!.push(ClassSchedule.fromJS(item));
            }
            if (Array.isArray(_data["exams"])) {
                this.exams = [] as any;
                for (let item of _data["exams"])
                    this.exams!.push(Exam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccademicYear {
        data = typeof data === 'object' ? data : {};
        let result = new AccademicYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["institutionId"] = this.institutionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["inscriptionFees"] = this.inscriptionFees;
        data["monthlyFees"] = this.monthlyFees;
        data["hasTransport"] = this.hasTransport;
        data["hasChildCare"] = this.hasChildCare;
        data["hasCanteen"] = this.hasCanteen;
        data["transportFees"] = this.transportFees;
        data["childCareFees"] = this.childCareFees;
        data["canteenFees"] = this.canteenFees;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.studentPaths)) {
            data["studentPaths"] = [];
            for (let item of this.studentPaths)
                data["studentPaths"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.teacherClassrooms)) {
            data["teacherClassrooms"] = [];
            for (let item of this.teacherClassrooms)
                data["teacherClassrooms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classSchedules)) {
            data["classSchedules"] = [];
            for (let item of this.classSchedules)
                data["classSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exams)) {
            data["exams"] = [];
            for (let item of this.exams)
                data["exams"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccademicYear {
    accademicYearId?: string;
    institutionId?: string;
    startDate?: Date;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    hasTransport?: boolean;
    hasChildCare?: boolean;
    hasCanteen?: boolean;
    transportFees?: number;
    childCareFees?: number;
    canteenFees?: number;
    payments?: Payment[] | undefined;
    studentPaths?: StudentPath[] | undefined;
    teacherClassrooms?: TeacherClassroom[] | undefined;
    classSchedules?: ClassSchedule[] | undefined;
    exams?: Exam[] | undefined;
}

export class AccademicYearDto implements IAccademicYearDto {
    accademicYearId?: string;
    institutionId?: string;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    hasTransport?: boolean;
    hasChildCare?: boolean;
    hasCanteen?: boolean;
    transportFees?: number;
    childCareFees?: number;
    canteenFees?: number;

    constructor(data?: IAccademicYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.institutionId = _data["institutionId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.inscriptionFees = _data["inscriptionFees"];
            this.monthlyFees = _data["monthlyFees"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.hasTransport = _data["hasTransport"];
            this.hasChildCare = _data["hasChildCare"];
            this.hasCanteen = _data["hasCanteen"];
            this.transportFees = _data["transportFees"];
            this.childCareFees = _data["childCareFees"];
            this.canteenFees = _data["canteenFees"];
        }
    }

    static fromJS(data: any): AccademicYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccademicYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["institutionId"] = this.institutionId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["inscriptionFees"] = this.inscriptionFees;
        data["monthlyFees"] = this.monthlyFees;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["hasTransport"] = this.hasTransport;
        data["hasChildCare"] = this.hasChildCare;
        data["hasCanteen"] = this.hasCanteen;
        data["transportFees"] = this.transportFees;
        data["childCareFees"] = this.childCareFees;
        data["canteenFees"] = this.canteenFees;
        return data;
    }
}

export interface IAccademicYearDto {
    accademicYearId?: string;
    institutionId?: string;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    hasTransport?: boolean;
    hasChildCare?: boolean;
    hasCanteen?: boolean;
    transportFees?: number;
    childCareFees?: number;
    canteenFees?: number;
}

export class ApplicationUser implements IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    isEnabled?: boolean;
    lastName?: string | undefined;
    readonly expenses?: Expense[] | undefined;
    readonly furnishers?: Furnisher[] | undefined;
    readonly inscriptions?: Inscription[] | undefined;
    readonly institutions?: Institution[] | undefined;
    readonly payments?: Payment[] | undefined;
    readonly services?: Service[] | undefined;
    readonly smsCampaigns?: SmsCampaign[] | undefined;
    readonly smsSent?: SmsSent[] | undefined;
    readonly studentPaths?: StudentPath[] | undefined;
    readonly students?: Student[] | undefined;
    teacher?: Teacher;

    constructor(data?: IApplicationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined as any;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.firstName = _data["firstName"];
            this.isEnabled = _data["isEnabled"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["expenses"])) {
                (this as any).expenses = [] as any;
                for (let item of _data["expenses"])
                    (this as any).expenses!.push(Expense.fromJS(item));
            }
            if (Array.isArray(_data["furnishers"])) {
                (this as any).furnishers = [] as any;
                for (let item of _data["furnishers"])
                    (this as any).furnishers!.push(Furnisher.fromJS(item));
            }
            if (Array.isArray(_data["inscriptions"])) {
                (this as any).inscriptions = [] as any;
                for (let item of _data["inscriptions"])
                    (this as any).inscriptions!.push(Inscription.fromJS(item));
            }
            if (Array.isArray(_data["institutions"])) {
                (this as any).institutions = [] as any;
                for (let item of _data["institutions"])
                    (this as any).institutions!.push(Institution.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                (this as any).payments = [] as any;
                for (let item of _data["payments"])
                    (this as any).payments!.push(Payment.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                (this as any).services = [] as any;
                for (let item of _data["services"])
                    (this as any).services!.push(Service.fromJS(item));
            }
            if (Array.isArray(_data["smsCampaigns"])) {
                (this as any).smsCampaigns = [] as any;
                for (let item of _data["smsCampaigns"])
                    (this as any).smsCampaigns!.push(SmsCampaign.fromJS(item));
            }
            if (Array.isArray(_data["smsSent"])) {
                (this as any).smsSent = [] as any;
                for (let item of _data["smsSent"])
                    (this as any).smsSent!.push(SmsSent.fromJS(item));
            }
            if (Array.isArray(_data["studentPaths"])) {
                (this as any).studentPaths = [] as any;
                for (let item of _data["studentPaths"])
                    (this as any).studentPaths!.push(StudentPath.fromJS(item));
            }
            if (Array.isArray(_data["students"])) {
                (this as any).students = [] as any;
                for (let item of _data["students"])
                    (this as any).students!.push(Student.fromJS(item));
            }
            this.teacher = _data["teacher"] ? Teacher.fromJS(_data["teacher"]) : undefined as any;
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined as any;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["firstName"] = this.firstName;
        data["isEnabled"] = this.isEnabled;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.furnishers)) {
            data["furnishers"] = [];
            for (let item of this.furnishers)
                data["furnishers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inscriptions)) {
            data["inscriptions"] = [];
            for (let item of this.inscriptions)
                data["inscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.institutions)) {
            data["institutions"] = [];
            for (let item of this.institutions)
                data["institutions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.smsCampaigns)) {
            data["smsCampaigns"] = [];
            for (let item of this.smsCampaigns)
                data["smsCampaigns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.smsSent)) {
            data["smsSent"] = [];
            for (let item of this.smsSent)
                data["smsSent"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.studentPaths)) {
            data["studentPaths"] = [];
            for (let item of this.studentPaths)
                data["studentPaths"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item ? item.toJSON() : undefined as any);
        }
        data["teacher"] = this.teacher ? this.teacher.toJSON() : undefined as any;
        return data;
    }
}

export interface IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    isEnabled?: boolean;
    lastName?: string | undefined;
    expenses?: Expense[] | undefined;
    furnishers?: Furnisher[] | undefined;
    inscriptions?: Inscription[] | undefined;
    institutions?: Institution[] | undefined;
    payments?: Payment[] | undefined;
    services?: Service[] | undefined;
    smsCampaigns?: SmsCampaign[] | undefined;
    smsSent?: SmsSent[] | undefined;
    studentPaths?: StudentPath[] | undefined;
    students?: Student[] | undefined;
    teacher?: Teacher;
}

export class ApplicationUserDto implements IApplicationUserDto {
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IApplicationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ApplicationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        return data;
    }
}

export interface IApplicationUserDto {
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class Classroom implements IClassroom {
    classroomId?: string;
    acronym?: string | undefined;
    name?: string | undefined;
    educationId?: string | undefined;
    enum?: number;
    education?: Education;
    studentPaths?: StudentPath[] | undefined;
    teacherClassrooms?: TeacherClassroom[] | undefined;
    classSchedules?: ClassSchedule[] | undefined;
    exams?: Exam[] | undefined;

    constructor(data?: IClassroom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classroomId = _data["classroomId"];
            this.acronym = _data["acronym"];
            this.name = _data["name"];
            this.educationId = _data["educationId"];
            this.enum = _data["enum"];
            this.education = _data["education"] ? Education.fromJS(_data["education"]) : undefined as any;
            if (Array.isArray(_data["studentPaths"])) {
                this.studentPaths = [] as any;
                for (let item of _data["studentPaths"])
                    this.studentPaths!.push(StudentPath.fromJS(item));
            }
            if (Array.isArray(_data["teacherClassrooms"])) {
                this.teacherClassrooms = [] as any;
                for (let item of _data["teacherClassrooms"])
                    this.teacherClassrooms!.push(TeacherClassroom.fromJS(item));
            }
            if (Array.isArray(_data["classSchedules"])) {
                this.classSchedules = [] as any;
                for (let item of _data["classSchedules"])
                    this.classSchedules!.push(ClassSchedule.fromJS(item));
            }
            if (Array.isArray(_data["exams"])) {
                this.exams = [] as any;
                for (let item of _data["exams"])
                    this.exams!.push(Exam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Classroom {
        data = typeof data === 'object' ? data : {};
        let result = new Classroom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classroomId"] = this.classroomId;
        data["acronym"] = this.acronym;
        data["name"] = this.name;
        data["educationId"] = this.educationId;
        data["enum"] = this.enum;
        data["education"] = this.education ? this.education.toJSON() : undefined as any;
        if (Array.isArray(this.studentPaths)) {
            data["studentPaths"] = [];
            for (let item of this.studentPaths)
                data["studentPaths"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.teacherClassrooms)) {
            data["teacherClassrooms"] = [];
            for (let item of this.teacherClassrooms)
                data["teacherClassrooms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classSchedules)) {
            data["classSchedules"] = [];
            for (let item of this.classSchedules)
                data["classSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exams)) {
            data["exams"] = [];
            for (let item of this.exams)
                data["exams"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassroom {
    classroomId?: string;
    acronym?: string | undefined;
    name?: string | undefined;
    educationId?: string | undefined;
    enum?: number;
    education?: Education;
    studentPaths?: StudentPath[] | undefined;
    teacherClassrooms?: TeacherClassroom[] | undefined;
    classSchedules?: ClassSchedule[] | undefined;
    exams?: Exam[] | undefined;
}

export class ClassroomDto implements IClassroomDto {
    classroomId?: string;
    acronym?: string | undefined;
    name?: string | undefined;
    educationId?: string | undefined;
    educationName?: string | undefined;
    enum?: number;

    constructor(data?: IClassroomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classroomId = _data["classroomId"];
            this.acronym = _data["acronym"];
            this.name = _data["name"];
            this.educationId = _data["educationId"];
            this.educationName = _data["educationName"];
            this.enum = _data["enum"];
        }
    }

    static fromJS(data: any): ClassroomDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassroomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classroomId"] = this.classroomId;
        data["acronym"] = this.acronym;
        data["name"] = this.name;
        data["educationId"] = this.educationId;
        data["educationName"] = this.educationName;
        data["enum"] = this.enum;
        return data;
    }
}

export interface IClassroomDto {
    classroomId?: string;
    acronym?: string | undefined;
    name?: string | undefined;
    educationId?: string | undefined;
    educationName?: string | undefined;
    enum?: number;
}

export class ClassSchedule implements IClassSchedule {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    classScheduleId?: string;
    classroomId?: string;
    teacherId?: string;
    subjectId?: string;
    accademicYearId?: string;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    classroom?: Classroom;
    teacher?: Teacher;
    subject?: Subject;
    accademicYear?: AccademicYear;

    constructor(data?: IClassSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.classScheduleId = _data["classScheduleId"];
            this.classroomId = _data["classroomId"];
            this.teacherId = _data["teacherId"];
            this.subjectId = _data["subjectId"];
            this.accademicYearId = _data["accademicYearId"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.classroom = _data["classroom"] ? Classroom.fromJS(_data["classroom"]) : undefined as any;
            this.teacher = _data["teacher"] ? Teacher.fromJS(_data["teacher"]) : undefined as any;
            this.subject = _data["subject"] ? Subject.fromJS(_data["subject"]) : undefined as any;
            this.accademicYear = _data["accademicYear"] ? AccademicYear.fromJS(_data["accademicYear"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClassSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ClassSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["classScheduleId"] = this.classScheduleId;
        data["classroomId"] = this.classroomId;
        data["teacherId"] = this.teacherId;
        data["subjectId"] = this.subjectId;
        data["accademicYearId"] = this.accademicYearId;
        data["dayOfWeek"] = this.dayOfWeek;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["classroom"] = this.classroom ? this.classroom.toJSON() : undefined as any;
        data["teacher"] = this.teacher ? this.teacher.toJSON() : undefined as any;
        data["subject"] = this.subject ? this.subject.toJSON() : undefined as any;
        data["accademicYear"] = this.accademicYear ? this.accademicYear.toJSON() : undefined as any;
        return data;
    }
}

export interface IClassSchedule {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    classScheduleId?: string;
    classroomId?: string;
    teacherId?: string;
    subjectId?: string;
    accademicYearId?: string;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
    classroom?: Classroom;
    teacher?: Teacher;
    subject?: Subject;
    accademicYear?: AccademicYear;
}

export class ClassScheduleDto implements IClassScheduleDto {
    classScheduleId?: string;
    classroomId?: string;
    classroomName?: string | undefined;
    teacherId?: string;
    teacherName?: string | undefined;
    subjectId?: string;
    subjectName?: string | undefined;
    accademicYearId?: string;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;

    constructor(data?: IClassScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classScheduleId = _data["classScheduleId"];
            this.classroomId = _data["classroomId"];
            this.classroomName = _data["classroomName"];
            this.teacherId = _data["teacherId"];
            this.teacherName = _data["teacherName"];
            this.subjectId = _data["subjectId"];
            this.subjectName = _data["subjectName"];
            this.accademicYearId = _data["accademicYearId"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): ClassScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classScheduleId"] = this.classScheduleId;
        data["classroomId"] = this.classroomId;
        data["classroomName"] = this.classroomName;
        data["teacherId"] = this.teacherId;
        data["teacherName"] = this.teacherName;
        data["subjectId"] = this.subjectId;
        data["subjectName"] = this.subjectName;
        data["accademicYearId"] = this.accademicYearId;
        data["dayOfWeek"] = this.dayOfWeek;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface IClassScheduleDto {
    classScheduleId?: string;
    classroomId?: string;
    classroomName?: string | undefined;
    teacherId?: string;
    teacherName?: string | undefined;
    subjectId?: string;
    subjectName?: string | undefined;
    accademicYearId?: string;
    dayOfWeek?: DayOfWeek;
    startTime?: string;
    endTime?: string;
}

export class CommunicationType implements ICommunicationType {
    communicationTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    severity?: number;
    template?: string | undefined;
    category?: number;
    smsCampaigns?: SmsCampaign[] | undefined;

    constructor(data?: ICommunicationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationTypeId = _data["communicationTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.severity = _data["severity"];
            this.template = _data["template"];
            this.category = _data["category"];
            if (Array.isArray(_data["smsCampaigns"])) {
                this.smsCampaigns = [] as any;
                for (let item of _data["smsCampaigns"])
                    this.smsCampaigns!.push(SmsCampaign.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationType {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationTypeId"] = this.communicationTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["severity"] = this.severity;
        data["template"] = this.template;
        data["category"] = this.category;
        if (Array.isArray(this.smsCampaigns)) {
            data["smsCampaigns"] = [];
            for (let item of this.smsCampaigns)
                data["smsCampaigns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICommunicationType {
    communicationTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    severity?: number;
    template?: string | undefined;
    category?: number;
    smsCampaigns?: SmsCampaign[] | undefined;
}

export class DashboardEducationDto implements IDashboardEducationDto {
    numberActiveStudent?: number;
    numberStudent?: number;
    numberStudentNursery?: number;
    numberStudentCanteen?: number;
    numberStudentTransport?: number;
    totalPayment?: number;
    totalStudentCost?: number;

    constructor(data?: IDashboardEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberActiveStudent = _data["numberActiveStudent"];
            this.numberStudent = _data["numberStudent"];
            this.numberStudentNursery = _data["numberStudentNursery"];
            this.numberStudentCanteen = _data["numberStudentCanteen"];
            this.numberStudentTransport = _data["numberStudentTransport"];
            this.totalPayment = _data["totalPayment"];
            this.totalStudentCost = _data["totalStudentCost"];
        }
    }

    static fromJS(data: any): DashboardEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberActiveStudent"] = this.numberActiveStudent;
        data["numberStudent"] = this.numberStudent;
        data["numberStudentNursery"] = this.numberStudentNursery;
        data["numberStudentCanteen"] = this.numberStudentCanteen;
        data["numberStudentTransport"] = this.numberStudentTransport;
        data["totalPayment"] = this.totalPayment;
        data["totalStudentCost"] = this.totalStudentCost;
        return data;
    }
}

export interface IDashboardEducationDto {
    numberActiveStudent?: number;
    numberStudent?: number;
    numberStudentNursery?: number;
    numberStudentCanteen?: number;
    numberStudentTransport?: number;
    totalPayment?: number;
    totalStudentCost?: number;
}

export class DashboardInscriptionDto implements IDashboardInscriptionDto {
    endDate!: Date;
    readonly entierServiceCost!: number;
    inscriptionFees!: number;
    inscriptionId?: string | undefined;
    inscriptionStatus!: InscriptionStatus;
    monthlyFees!: number;
    serviceType!: ServiceType;
    startDate!: Date;
    studentPathId!: string;
    readonly todayCost!: number;

    constructor(data?: IDashboardInscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            (this as any).entierServiceCost = _data["entierServiceCost"];
            this.inscriptionFees = _data["inscriptionFees"];
            this.inscriptionId = _data["inscriptionId"];
            this.inscriptionStatus = _data["inscriptionStatus"];
            this.monthlyFees = _data["monthlyFees"];
            this.serviceType = _data["serviceType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.studentPathId = _data["studentPathId"];
            (this as any).todayCost = _data["todayCost"];
        }
    }

    static fromJS(data: any): DashboardInscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardInscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["entierServiceCost"] = this.entierServiceCost;
        data["inscriptionFees"] = this.inscriptionFees;
        data["inscriptionId"] = this.inscriptionId;
        data["inscriptionStatus"] = this.inscriptionStatus;
        data["monthlyFees"] = this.monthlyFees;
        data["serviceType"] = this.serviceType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["studentPathId"] = this.studentPathId;
        data["todayCost"] = this.todayCost;
        return data;
    }
}

export interface IDashboardInscriptionDto {
    endDate: Date;
    entierServiceCost: number;
    inscriptionFees: number;
    inscriptionId?: string | undefined;
    inscriptionStatus: InscriptionStatus;
    monthlyFees: number;
    serviceType: ServiceType;
    startDate: Date;
    studentPathId: string;
    todayCost: number;
}

export class DashboardSchoolDto implements IDashboardSchoolDto {
    accademicYearId?: string;
    endDate?: Date;
    numberStudent?: number;
    numberActiveStudent?: number;
    numberStudentNursery?: number;
    numberStudentCanteen?: number;
    numberStudentTransport?: number;
    startDate?: Date;
    totalExpense?: number;
    totalPayment?: number;
    totalStudentCost?: number;

    constructor(data?: IDashboardSchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.numberStudent = _data["numberStudent"];
            this.numberActiveStudent = _data["numberActiveStudent"];
            this.numberStudentNursery = _data["numberStudentNursery"];
            this.numberStudentCanteen = _data["numberStudentCanteen"];
            this.numberStudentTransport = _data["numberStudentTransport"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.totalExpense = _data["totalExpense"];
            this.totalPayment = _data["totalPayment"];
            this.totalStudentCost = _data["totalStudentCost"];
        }
    }

    static fromJS(data: any): DashboardSchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["numberStudent"] = this.numberStudent;
        data["numberActiveStudent"] = this.numberActiveStudent;
        data["numberStudentNursery"] = this.numberStudentNursery;
        data["numberStudentCanteen"] = this.numberStudentCanteen;
        data["numberStudentTransport"] = this.numberStudentTransport;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["totalExpense"] = this.totalExpense;
        data["totalPayment"] = this.totalPayment;
        data["totalStudentCost"] = this.totalStudentCost;
        return data;
    }
}

export interface IDashboardSchoolDto {
    accademicYearId?: string;
    endDate?: Date;
    numberStudent?: number;
    numberActiveStudent?: number;
    numberStudentNursery?: number;
    numberStudentCanteen?: number;
    numberStudentTransport?: number;
    startDate?: Date;
    totalExpense?: number;
    totalPayment?: number;
    totalStudentCost?: number;
}

export class DashboardStudentDto implements IDashboardStudentDto {
    dateOfLastPayment?: Date | undefined;
    readonly entierServicesCost?: number;
    nurseryInscription?: DashboardInscriptionDto;
    historyNurseryInscription?: DashboardInscriptionDto[] | undefined;
    studentPath?: DashboardInscriptionDto;
    readonly todayCost?: number;
    totalPayments?: number;
    transportTotalPayments?: number;
    nurseryTotalPayments?: number;
    transportInscription?: DashboardInscriptionDto;
    historyTransportInscription?: DashboardInscriptionDto[] | undefined;
    canteenInscription?: DashboardInscriptionDto;
    historyCanteenInscription?: DashboardInscriptionDto[] | undefined;

    constructor(data?: IDashboardStudentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfLastPayment = _data["dateOfLastPayment"] ? new Date(_data["dateOfLastPayment"].toString()) : undefined as any;
            (this as any).entierServicesCost = _data["entierServicesCost"];
            this.nurseryInscription = _data["nurseryInscription"] ? DashboardInscriptionDto.fromJS(_data["nurseryInscription"]) : undefined as any;
            if (Array.isArray(_data["historyNurseryInscription"])) {
                this.historyNurseryInscription = [] as any;
                for (let item of _data["historyNurseryInscription"])
                    this.historyNurseryInscription!.push(DashboardInscriptionDto.fromJS(item));
            }
            this.studentPath = _data["studentPath"] ? DashboardInscriptionDto.fromJS(_data["studentPath"]) : undefined as any;
            (this as any).todayCost = _data["todayCost"];
            this.totalPayments = _data["totalPayments"];
            this.transportTotalPayments = _data["transportTotalPayments"];
            this.nurseryTotalPayments = _data["nurseryTotalPayments"];
            this.transportInscription = _data["transportInscription"] ? DashboardInscriptionDto.fromJS(_data["transportInscription"]) : undefined as any;
            if (Array.isArray(_data["historyTransportInscription"])) {
                this.historyTransportInscription = [] as any;
                for (let item of _data["historyTransportInscription"])
                    this.historyTransportInscription!.push(DashboardInscriptionDto.fromJS(item));
            }
            this.canteenInscription = _data["canteenInscription"] ? DashboardInscriptionDto.fromJS(_data["canteenInscription"]) : undefined as any;
            if (Array.isArray(_data["historyCanteenInscription"])) {
                this.historyCanteenInscription = [] as any;
                for (let item of _data["historyCanteenInscription"])
                    this.historyCanteenInscription!.push(DashboardInscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardStudentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStudentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfLastPayment"] = this.dateOfLastPayment ? this.dateOfLastPayment.toISOString() : undefined as any;
        data["entierServicesCost"] = this.entierServicesCost;
        data["nurseryInscription"] = this.nurseryInscription ? this.nurseryInscription.toJSON() : undefined as any;
        if (Array.isArray(this.historyNurseryInscription)) {
            data["historyNurseryInscription"] = [];
            for (let item of this.historyNurseryInscription)
                data["historyNurseryInscription"].push(item ? item.toJSON() : undefined as any);
        }
        data["studentPath"] = this.studentPath ? this.studentPath.toJSON() : undefined as any;
        data["todayCost"] = this.todayCost;
        data["totalPayments"] = this.totalPayments;
        data["transportTotalPayments"] = this.transportTotalPayments;
        data["nurseryTotalPayments"] = this.nurseryTotalPayments;
        data["transportInscription"] = this.transportInscription ? this.transportInscription.toJSON() : undefined as any;
        if (Array.isArray(this.historyTransportInscription)) {
            data["historyTransportInscription"] = [];
            for (let item of this.historyTransportInscription)
                data["historyTransportInscription"].push(item ? item.toJSON() : undefined as any);
        }
        data["canteenInscription"] = this.canteenInscription ? this.canteenInscription.toJSON() : undefined as any;
        if (Array.isArray(this.historyCanteenInscription)) {
            data["historyCanteenInscription"] = [];
            for (let item of this.historyCanteenInscription)
                data["historyCanteenInscription"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDashboardStudentDto {
    dateOfLastPayment?: Date | undefined;
    entierServicesCost?: number;
    nurseryInscription?: DashboardInscriptionDto;
    historyNurseryInscription?: DashboardInscriptionDto[] | undefined;
    studentPath?: DashboardInscriptionDto;
    todayCost?: number;
    totalPayments?: number;
    transportTotalPayments?: number;
    nurseryTotalPayments?: number;
    transportInscription?: DashboardInscriptionDto;
    historyTransportInscription?: DashboardInscriptionDto[] | undefined;
    canteenInscription?: DashboardInscriptionDto;
    historyCanteenInscription?: DashboardInscriptionDto[] | undefined;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class DoubleChartDto implements IDoubleChartDto {
    id?: string;
    name?: string | undefined;
    date?: Date;
    value?: number;
    value2?: number;

    constructor(data?: IDoubleChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.value = _data["value"];
            this.value2 = _data["value2"];
        }
    }

    static fromJS(data: any): DoubleChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["value"] = this.value;
        data["value2"] = this.value2;
        return data;
    }
}

export interface IDoubleChartDto {
    id?: string;
    name?: string | undefined;
    date?: Date;
    value?: number;
    value2?: number;
}

export class Education implements IEducation {
    educationId?: string;
    institutionId?: string;
    name?: string | undefined;
    enum?: number;
    classrooms?: Classroom[] | undefined;

    constructor(data?: IEducation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationId = _data["educationId"];
            this.institutionId = _data["institutionId"];
            this.name = _data["name"];
            this.enum = _data["enum"];
            if (Array.isArray(_data["classrooms"])) {
                this.classrooms = [] as any;
                for (let item of _data["classrooms"])
                    this.classrooms!.push(Classroom.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Education {
        data = typeof data === 'object' ? data : {};
        let result = new Education();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationId"] = this.educationId;
        data["institutionId"] = this.institutionId;
        data["name"] = this.name;
        data["enum"] = this.enum;
        if (Array.isArray(this.classrooms)) {
            data["classrooms"] = [];
            for (let item of this.classrooms)
                data["classrooms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEducation {
    educationId?: string;
    institutionId?: string;
    name?: string | undefined;
    enum?: number;
    classrooms?: Classroom[] | undefined;
}

export class EducationDto implements IEducationDto {
    classrooms?: ClassroomDto[] | undefined;
    educationId?: string;
    institutionId?: string;
    enum?: number;
    name?: string | undefined;

    constructor(data?: IEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["classrooms"])) {
                this.classrooms = [] as any;
                for (let item of _data["classrooms"])
                    this.classrooms!.push(ClassroomDto.fromJS(item));
            }
            this.educationId = _data["educationId"];
            this.institutionId = _data["institutionId"];
            this.enum = _data["enum"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.classrooms)) {
            data["classrooms"] = [];
            for (let item of this.classrooms)
                data["classrooms"].push(item ? item.toJSON() : undefined as any);
        }
        data["educationId"] = this.educationId;
        data["institutionId"] = this.institutionId;
        data["enum"] = this.enum;
        data["name"] = this.name;
        return data;
    }
}

export interface IEducationDto {
    classrooms?: ClassroomDto[] | undefined;
    educationId?: string;
    institutionId?: string;
    enum?: number;
    name?: string | undefined;
}

export class Exam implements IExam {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    examId?: string;
    accademicYearId?: string;
    teacherId?: string;
    classroomId?: string;
    name?: string | undefined;
    date?: Date;
    accademicYear?: AccademicYear;
    teacher?: Teacher;
    classroom?: Classroom;
    examGrades?: ExamGrade[] | undefined;

    constructor(data?: IExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.examId = _data["examId"];
            this.accademicYearId = _data["accademicYearId"];
            this.teacherId = _data["teacherId"];
            this.classroomId = _data["classroomId"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.accademicYear = _data["accademicYear"] ? AccademicYear.fromJS(_data["accademicYear"]) : undefined as any;
            this.teacher = _data["teacher"] ? Teacher.fromJS(_data["teacher"]) : undefined as any;
            this.classroom = _data["classroom"] ? Classroom.fromJS(_data["classroom"]) : undefined as any;
            if (Array.isArray(_data["examGrades"])) {
                this.examGrades = [] as any;
                for (let item of _data["examGrades"])
                    this.examGrades!.push(ExamGrade.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Exam {
        data = typeof data === 'object' ? data : {};
        let result = new Exam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["examId"] = this.examId;
        data["accademicYearId"] = this.accademicYearId;
        data["teacherId"] = this.teacherId;
        data["classroomId"] = this.classroomId;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["accademicYear"] = this.accademicYear ? this.accademicYear.toJSON() : undefined as any;
        data["teacher"] = this.teacher ? this.teacher.toJSON() : undefined as any;
        data["classroom"] = this.classroom ? this.classroom.toJSON() : undefined as any;
        if (Array.isArray(this.examGrades)) {
            data["examGrades"] = [];
            for (let item of this.examGrades)
                data["examGrades"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExam {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    examId?: string;
    accademicYearId?: string;
    teacherId?: string;
    classroomId?: string;
    name?: string | undefined;
    date?: Date;
    accademicYear?: AccademicYear;
    teacher?: Teacher;
    classroom?: Classroom;
    examGrades?: ExamGrade[] | undefined;
}

export class ExamDto implements IExamDto {
    examId?: string;
    accademicYearId?: string;
    teacherId?: string;
    teacherName?: string | undefined;
    classroomId?: string;
    classroomName?: string | undefined;
    subjectId?: string;
    subjectName?: string | undefined;
    name?: string | undefined;
    date?: Date;

    constructor(data?: IExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.accademicYearId = _data["accademicYearId"];
            this.teacherId = _data["teacherId"];
            this.teacherName = _data["teacherName"];
            this.classroomId = _data["classroomId"];
            this.classroomName = _data["classroomName"];
            this.subjectId = _data["subjectId"];
            this.subjectName = _data["subjectName"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["accademicYearId"] = this.accademicYearId;
        data["teacherId"] = this.teacherId;
        data["teacherName"] = this.teacherName;
        data["classroomId"] = this.classroomId;
        data["classroomName"] = this.classroomName;
        data["subjectId"] = this.subjectId;
        data["subjectName"] = this.subjectName;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }
}

export interface IExamDto {
    examId?: string;
    accademicYearId?: string;
    teacherId?: string;
    teacherName?: string | undefined;
    classroomId?: string;
    classroomName?: string | undefined;
    subjectId?: string;
    subjectName?: string | undefined;
    name?: string | undefined;
    date?: Date;
}

export class ExamGrade implements IExamGrade {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    examGradeId?: string;
    studentPathId?: string;
    teacherId?: string;
    examId?: string;
    gradeValue?: number;
    gradeText?: string | undefined;
    date?: Date;
    comment?: string | undefined;
    studentPath?: StudentPath;
    teacher?: Teacher;
    exam?: Exam;

    constructor(data?: IExamGrade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.examGradeId = _data["examGradeId"];
            this.studentPathId = _data["studentPathId"];
            this.teacherId = _data["teacherId"];
            this.examId = _data["examId"];
            this.gradeValue = _data["gradeValue"];
            this.gradeText = _data["gradeText"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.studentPath = _data["studentPath"] ? StudentPath.fromJS(_data["studentPath"]) : undefined as any;
            this.teacher = _data["teacher"] ? Teacher.fromJS(_data["teacher"]) : undefined as any;
            this.exam = _data["exam"] ? Exam.fromJS(_data["exam"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExamGrade {
        data = typeof data === 'object' ? data : {};
        let result = new ExamGrade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["examGradeId"] = this.examGradeId;
        data["studentPathId"] = this.studentPathId;
        data["teacherId"] = this.teacherId;
        data["examId"] = this.examId;
        data["gradeValue"] = this.gradeValue;
        data["gradeText"] = this.gradeText;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["comment"] = this.comment;
        data["studentPath"] = this.studentPath ? this.studentPath.toJSON() : undefined as any;
        data["teacher"] = this.teacher ? this.teacher.toJSON() : undefined as any;
        data["exam"] = this.exam ? this.exam.toJSON() : undefined as any;
        return data;
    }
}

export interface IExamGrade {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    examGradeId?: string;
    studentPathId?: string;
    teacherId?: string;
    examId?: string;
    gradeValue?: number;
    gradeText?: string | undefined;
    date?: Date;
    comment?: string | undefined;
    studentPath?: StudentPath;
    teacher?: Teacher;
    exam?: Exam;
}

export class ExamGradeDto implements IExamGradeDto {
    examGradeId?: string;
    examId?: string;
    studentPathId?: string;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    teacherId?: string;
    teacherName?: string | undefined;
    subjectName?: string | undefined;
    gradeValue?: number;
    gradeText?: string | undefined;
    date?: Date;
    comment?: string | undefined;

    constructor(data?: IExamGradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examGradeId = _data["examGradeId"];
            this.examId = _data["examId"];
            this.studentPathId = _data["studentPathId"];
            this.studentFirstName = _data["studentFirstName"];
            this.studentLastName = _data["studentLastName"];
            this.teacherId = _data["teacherId"];
            this.teacherName = _data["teacherName"];
            this.subjectName = _data["subjectName"];
            this.gradeValue = _data["gradeValue"];
            this.gradeText = _data["gradeText"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ExamGradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamGradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examGradeId"] = this.examGradeId;
        data["examId"] = this.examId;
        data["studentPathId"] = this.studentPathId;
        data["studentFirstName"] = this.studentFirstName;
        data["studentLastName"] = this.studentLastName;
        data["teacherId"] = this.teacherId;
        data["teacherName"] = this.teacherName;
        data["subjectName"] = this.subjectName;
        data["gradeValue"] = this.gradeValue;
        data["gradeText"] = this.gradeText;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IExamGradeDto {
    examGradeId?: string;
    examId?: string;
    studentPathId?: string;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    teacherId?: string;
    teacherName?: string | undefined;
    subjectName?: string | undefined;
    gradeValue?: number;
    gradeText?: string | undefined;
    date?: Date;
    comment?: string | undefined;
}

export class Expense implements IExpense {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    expenseId?: string;
    amount?: number;
    comment?: string | undefined;
    date?: Date;
    furnisherId?: string;
    institutionId?: string;
    paymentTermId?: number;
    furnisher?: Furnisher;

    constructor(data?: IExpense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.expenseId = _data["expenseId"];
            this.amount = _data["amount"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.furnisherId = _data["furnisherId"];
            this.institutionId = _data["institutionId"];
            this.paymentTermId = _data["paymentTermId"];
            this.furnisher = _data["furnisher"] ? Furnisher.fromJS(_data["furnisher"]) : undefined as any;
        }
    }

    static fromJS(data: any): Expense {
        data = typeof data === 'object' ? data : {};
        let result = new Expense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["expenseId"] = this.expenseId;
        data["amount"] = this.amount;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["furnisherId"] = this.furnisherId;
        data["institutionId"] = this.institutionId;
        data["paymentTermId"] = this.paymentTermId;
        data["furnisher"] = this.furnisher ? this.furnisher.toJSON() : undefined as any;
        return data;
    }
}

export interface IExpense {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    expenseId?: string;
    amount?: number;
    comment?: string | undefined;
    date?: Date;
    furnisherId?: string;
    institutionId?: string;
    paymentTermId?: number;
    furnisher?: Furnisher;
}

export class ExpenseDto implements IExpenseDto {
    amount!: number;
    comment?: string | undefined;
    date!: Date;
    expenseId!: string;
    furnisherId!: string;
    paymentTermId!: number;
    furnisher?: FurnisherDto;
    institutionId!: string;

    constructor(data?: IExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.expenseId = _data["expenseId"];
            this.furnisherId = _data["furnisherId"];
            this.paymentTermId = _data["paymentTermId"];
            this.furnisher = _data["furnisher"] ? FurnisherDto.fromJS(_data["furnisher"]) : undefined as any;
            this.institutionId = _data["institutionId"];
        }
    }

    static fromJS(data: any): ExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["expenseId"] = this.expenseId;
        data["furnisherId"] = this.furnisherId;
        data["paymentTermId"] = this.paymentTermId;
        data["furnisher"] = this.furnisher ? this.furnisher.toJSON() : undefined as any;
        data["institutionId"] = this.institutionId;
        return data;
    }
}

export interface IExpenseDto {
    amount: number;
    comment?: string | undefined;
    date: Date;
    expenseId: string;
    furnisherId: string;
    paymentTermId: number;
    furnisher?: FurnisherDto;
    institutionId: string;
}

export class ExpenseDtoAmountPaginatedDto implements IExpenseDtoAmountPaginatedDto {
    data?: ExpenseDto[] | undefined;
    pages?: number;
    totalElements?: number;
    totalAmount?: number;

    constructor(data?: IExpenseDtoAmountPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExpenseDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): ExpenseDtoAmountPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseDtoAmountPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IExpenseDtoAmountPaginatedDto {
    data?: ExpenseDto[] | undefined;
    pages?: number;
    totalElements?: number;
    totalAmount?: number;
}

export class ExpenseFilterDto implements IExpenseFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    furnishers?: string[] | undefined;

    constructor(data?: IExpenseFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.institutionId = _data["institutionId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["furnishers"])) {
                this.furnishers = [] as any;
                for (let item of _data["furnishers"])
                    this.furnishers!.push(item);
            }
        }
    }

    static fromJS(data: any): ExpenseFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["institutionId"] = this.institutionId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.furnishers)) {
            data["furnishers"] = [];
            for (let item of this.furnishers)
                data["furnishers"].push(item);
        }
        return data;
    }
}

export interface IExpenseFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    furnishers?: string[] | undefined;
}

export class FilterDto implements IFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;

    constructor(data?: IFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.institutionId = _data["institutionId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): FilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["institutionId"] = this.institutionId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
}

export class Furnisher implements IFurnisher {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    furnisherId?: string;
    name?: string | undefined;
    institutionId?: string;
    expenses?: Expense[] | undefined;

    constructor(data?: IFurnisher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.furnisherId = _data["furnisherId"];
            this.name = _data["name"];
            this.institutionId = _data["institutionId"];
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(Expense.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Furnisher {
        data = typeof data === 'object' ? data : {};
        let result = new Furnisher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["furnisherId"] = this.furnisherId;
        data["name"] = this.name;
        data["institutionId"] = this.institutionId;
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFurnisher {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    furnisherId?: string;
    name?: string | undefined;
    institutionId?: string;
    expenses?: Expense[] | undefined;
}

export class FurnisherDto implements IFurnisherDto {
    furnisherId?: string;
    name?: string | undefined;
    institutionId?: string;

    constructor(data?: IFurnisherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherId = _data["furnisherId"];
            this.name = _data["name"];
            this.institutionId = _data["institutionId"];
        }
    }

    static fromJS(data: any): FurnisherDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherId"] = this.furnisherId;
        data["name"] = this.name;
        data["institutionId"] = this.institutionId;
        return data;
    }
}

export interface IFurnisherDto {
    furnisherId?: string;
    name?: string | undefined;
    institutionId?: string;
}

export class FurnisherExpenseFilterDto implements IFurnisherExpenseFilterDto {
    furnisherId?: string;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IFurnisherExpenseFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherId = _data["furnisherId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FurnisherExpenseFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherExpenseFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherId"] = this.furnisherId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IFurnisherExpenseFilterDto {
    furnisherId?: string;
    startDate?: Date;
    endDate?: Date;
}

export class FurnisherExpenseStatisticDto implements IFurnisherExpenseStatisticDto {
    furnisherId?: string;
    furnisherName?: string | undefined;
    count?: number;
    totalAmount?: number;

    constructor(data?: IFurnisherExpenseStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.furnisherId = _data["furnisherId"];
            this.furnisherName = _data["furnisherName"];
            this.count = _data["count"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): FurnisherExpenseStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnisherExpenseStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["furnisherId"] = this.furnisherId;
        data["furnisherName"] = this.furnisherName;
        data["count"] = this.count;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IFurnisherExpenseStatisticDto {
    furnisherId?: string;
    furnisherName?: string | undefined;
    count?: number;
    totalAmount?: number;
}

export class Inscription implements IInscription {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    inscriptionId?: string;
    endDate?: Date;
    startDate?: Date;
    monthlyFees?: number;
    studentPathId?: string;
    serviceId?: string;
    service?: Service;
    studentPath?: StudentPath;

    constructor(data?: IInscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.inscriptionId = _data["inscriptionId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.monthlyFees = _data["monthlyFees"];
            this.studentPathId = _data["studentPathId"];
            this.serviceId = _data["serviceId"];
            this.service = _data["service"] ? Service.fromJS(_data["service"]) : undefined as any;
            this.studentPath = _data["studentPath"] ? StudentPath.fromJS(_data["studentPath"]) : undefined as any;
        }
    }

    static fromJS(data: any): Inscription {
        data = typeof data === 'object' ? data : {};
        let result = new Inscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["inscriptionId"] = this.inscriptionId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["monthlyFees"] = this.monthlyFees;
        data["studentPathId"] = this.studentPathId;
        data["serviceId"] = this.serviceId;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["studentPath"] = this.studentPath ? this.studentPath.toJSON() : undefined as any;
        return data;
    }
}

export interface IInscription {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    inscriptionId?: string;
    endDate?: Date;
    startDate?: Date;
    monthlyFees?: number;
    studentPathId?: string;
    serviceId?: string;
    service?: Service;
    studentPath?: StudentPath;
}

export class InscriptionDto implements IInscriptionDto {
    endDate?: Date;
    inscriptionId?: string;
    monthlyFees?: number;
    service?: ServiceDto;
    serviceId?: string;
    studentPathId?: string;
    startDate?: Date;

    constructor(data?: IInscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.inscriptionId = _data["inscriptionId"];
            this.monthlyFees = _data["monthlyFees"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : undefined as any;
            this.serviceId = _data["serviceId"];
            this.studentPathId = _data["studentPathId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["inscriptionId"] = this.inscriptionId;
        data["monthlyFees"] = this.monthlyFees;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["serviceId"] = this.serviceId;
        data["studentPathId"] = this.studentPathId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IInscriptionDto {
    endDate?: Date;
    inscriptionId?: string;
    monthlyFees?: number;
    service?: ServiceDto;
    serviceId?: string;
    studentPathId?: string;
    startDate?: Date;
}

export enum InscriptionStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Institution implements IInstitution {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    address?: string | undefined;
    city?: string | undefined;
    emailContact?: string | undefined;
    institutionId?: string;
    logo?: string | undefined;
    institutionImage?: string | undefined;
    name?: string | undefined;
    telephoneContact?: string | undefined;
    website?: string | undefined;
    receiptFormat?: string | undefined;
    receiptOrientation?: string | undefined;
    printReceiptNumber?: boolean;
    printReceiptQrCode?: boolean;

    constructor(data?: IInstitution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.address = _data["address"];
            this.city = _data["city"];
            this.emailContact = _data["emailContact"];
            this.institutionId = _data["institutionId"];
            this.logo = _data["logo"];
            this.institutionImage = _data["institutionImage"];
            this.name = _data["name"];
            this.telephoneContact = _data["telephoneContact"];
            this.website = _data["website"];
            this.receiptFormat = _data["receiptFormat"];
            this.receiptOrientation = _data["receiptOrientation"];
            this.printReceiptNumber = _data["printReceiptNumber"];
            this.printReceiptQrCode = _data["printReceiptQrCode"];
        }
    }

    static fromJS(data: any): Institution {
        data = typeof data === 'object' ? data : {};
        let result = new Institution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["address"] = this.address;
        data["city"] = this.city;
        data["emailContact"] = this.emailContact;
        data["institutionId"] = this.institutionId;
        data["logo"] = this.logo;
        data["institutionImage"] = this.institutionImage;
        data["name"] = this.name;
        data["telephoneContact"] = this.telephoneContact;
        data["website"] = this.website;
        data["receiptFormat"] = this.receiptFormat;
        data["receiptOrientation"] = this.receiptOrientation;
        data["printReceiptNumber"] = this.printReceiptNumber;
        data["printReceiptQrCode"] = this.printReceiptQrCode;
        return data;
    }
}

export interface IInstitution {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    address?: string | undefined;
    city?: string | undefined;
    emailContact?: string | undefined;
    institutionId?: string;
    logo?: string | undefined;
    institutionImage?: string | undefined;
    name?: string | undefined;
    telephoneContact?: string | undefined;
    website?: string | undefined;
    receiptFormat?: string | undefined;
    receiptOrientation?: string | undefined;
    printReceiptNumber?: boolean;
    printReceiptQrCode?: boolean;
}

export class InstitutionDto implements IInstitutionDto {
    address?: string | undefined;
    city?: string | undefined;
    emailContact?: string | undefined;
    name?: string | undefined;
    telephoneContact?: string | undefined;
    website?: string | undefined;
    receiptFormat?: string | undefined;
    receiptOrientation?: string | undefined;
    printReceiptNumber?: boolean;
    printReceiptQrCode?: boolean;

    constructor(data?: IInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.emailContact = _data["emailContact"];
            this.name = _data["name"];
            this.telephoneContact = _data["telephoneContact"];
            this.website = _data["website"];
            this.receiptFormat = _data["receiptFormat"];
            this.receiptOrientation = _data["receiptOrientation"];
            this.printReceiptNumber = _data["printReceiptNumber"];
            this.printReceiptQrCode = _data["printReceiptQrCode"];
        }
    }

    static fromJS(data: any): InstitutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["emailContact"] = this.emailContact;
        data["name"] = this.name;
        data["telephoneContact"] = this.telephoneContact;
        data["website"] = this.website;
        data["receiptFormat"] = this.receiptFormat;
        data["receiptOrientation"] = this.receiptOrientation;
        data["printReceiptNumber"] = this.printReceiptNumber;
        data["printReceiptQrCode"] = this.printReceiptQrCode;
        return data;
    }
}

export interface IInstitutionDto {
    address?: string | undefined;
    city?: string | undefined;
    emailContact?: string | undefined;
    name?: string | undefined;
    telephoneContact?: string | undefined;
    website?: string | undefined;
    receiptFormat?: string | undefined;
    receiptOrientation?: string | undefined;
    printReceiptNumber?: boolean;
    printReceiptQrCode?: boolean;
}

export class LoginDto implements ILoginDto {
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginDto {
    userName?: string | undefined;
    password?: string | undefined;
}

export class LoginResultDto implements ILoginResultDto {
    message?: string | undefined;
    token?: string | undefined;

    constructor(data?: ILoginResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): LoginResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["token"] = this.token;
        return data;
    }
}

export interface ILoginResultDto {
    message?: string | undefined;
    token?: string | undefined;
}

export class NewStudentPathDto implements INewStudentPathDto {
    accademicYearId?: string;
    classroomId?: string;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    studentId?: string;
    hasTransport?: boolean;
    transportFees?: number;
    hasChildCare?: boolean;
    childCareFees?: number;
    hasCanteen?: boolean;
    canteenFees?: number;

    constructor(data?: INewStudentPathDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.classroomId = _data["classroomId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.inscriptionFees = _data["inscriptionFees"];
            this.monthlyFees = _data["monthlyFees"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.studentId = _data["studentId"];
            this.hasTransport = _data["hasTransport"];
            this.transportFees = _data["transportFees"];
            this.hasChildCare = _data["hasChildCare"];
            this.childCareFees = _data["childCareFees"];
            this.hasCanteen = _data["hasCanteen"];
            this.canteenFees = _data["canteenFees"];
        }
    }

    static fromJS(data: any): NewStudentPathDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewStudentPathDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["classroomId"] = this.classroomId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["inscriptionFees"] = this.inscriptionFees;
        data["monthlyFees"] = this.monthlyFees;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["studentId"] = this.studentId;
        data["hasTransport"] = this.hasTransport;
        data["transportFees"] = this.transportFees;
        data["hasChildCare"] = this.hasChildCare;
        data["childCareFees"] = this.childCareFees;
        data["hasCanteen"] = this.hasCanteen;
        data["canteenFees"] = this.canteenFees;
        return data;
    }
}

export interface INewStudentPathDto {
    accademicYearId?: string;
    classroomId?: string;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    studentId?: string;
    hasTransport?: boolean;
    transportFees?: number;
    hasChildCare?: boolean;
    childCareFees?: number;
    hasCanteen?: boolean;
    canteenFees?: number;
}

export class NotificationDto implements INotificationDto {
    message?: string | undefined;
    communicationTypeId?: number;
    smsSubscriptionId?: string;
    customRecipient?: string[] | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.communicationTypeId = _data["communicationTypeId"];
            this.smsSubscriptionId = _data["smsSubscriptionId"];
            if (Array.isArray(_data["customRecipient"])) {
                this.customRecipient = [] as any;
                for (let item of _data["customRecipient"])
                    this.customRecipient!.push(item);
            }
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["communicationTypeId"] = this.communicationTypeId;
        data["smsSubscriptionId"] = this.smsSubscriptionId;
        if (Array.isArray(this.customRecipient)) {
            data["customRecipient"] = [];
            for (let item of this.customRecipient)
                data["customRecipient"].push(item);
        }
        return data;
    }
}

export interface INotificationDto {
    message?: string | undefined;
    communicationTypeId?: number;
    smsSubscriptionId?: string;
    customRecipient?: string[] | undefined;
}

export class Parent implements IParent {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    emailContact?: string | undefined;
    firstName?: string | undefined;
    institutionId?: string;
    lastName?: string | undefined;
    mobileContact?: string | undefined;
    parentId?: string;
    smsSent?: SmsSent[] | undefined;
    students?: ParentStudent[] | undefined;

    constructor(data?: IParent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.emailContact = _data["emailContact"];
            this.firstName = _data["firstName"];
            this.institutionId = _data["institutionId"];
            this.lastName = _data["lastName"];
            this.mobileContact = _data["mobileContact"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["smsSent"])) {
                this.smsSent = [] as any;
                for (let item of _data["smsSent"])
                    this.smsSent!.push(SmsSent.fromJS(item));
            }
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(ParentStudent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Parent {
        data = typeof data === 'object' ? data : {};
        let result = new Parent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["emailContact"] = this.emailContact;
        data["firstName"] = this.firstName;
        data["institutionId"] = this.institutionId;
        data["lastName"] = this.lastName;
        data["mobileContact"] = this.mobileContact;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.smsSent)) {
            data["smsSent"] = [];
            for (let item of this.smsSent)
                data["smsSent"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParent {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    emailContact?: string | undefined;
    firstName?: string | undefined;
    institutionId?: string;
    lastName?: string | undefined;
    mobileContact?: string | undefined;
    parentId?: string;
    smsSent?: SmsSent[] | undefined;
    students?: ParentStudent[] | undefined;
}

export class ParentCreationDto implements IParentCreationDto {
    parentId?: string;
    institutionId?: string;
    emailContact?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobileContact?: string | undefined;
    childrenCount?: number;
    studentIds?: string[] | undefined;

    constructor(data?: IParentCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.institutionId = _data["institutionId"];
            this.emailContact = _data["emailContact"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobileContact = _data["mobileContact"];
            this.childrenCount = _data["childrenCount"];
            if (Array.isArray(_data["studentIds"])) {
                this.studentIds = [] as any;
                for (let item of _data["studentIds"])
                    this.studentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ParentCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["institutionId"] = this.institutionId;
        data["emailContact"] = this.emailContact;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileContact"] = this.mobileContact;
        data["childrenCount"] = this.childrenCount;
        if (Array.isArray(this.studentIds)) {
            data["studentIds"] = [];
            for (let item of this.studentIds)
                data["studentIds"].push(item);
        }
        return data;
    }
}

export interface IParentCreationDto {
    parentId?: string;
    institutionId?: string;
    emailContact?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobileContact?: string | undefined;
    childrenCount?: number;
    studentIds?: string[] | undefined;
}

export class ParentDto implements IParentDto {
    parentId?: string;
    institutionId?: string;
    emailContact?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobileContact?: string | undefined;
    childrenCount?: number;

    constructor(data?: IParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.institutionId = _data["institutionId"];
            this.emailContact = _data["emailContact"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobileContact = _data["mobileContact"];
            this.childrenCount = _data["childrenCount"];
        }
    }

    static fromJS(data: any): ParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["institutionId"] = this.institutionId;
        data["emailContact"] = this.emailContact;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileContact"] = this.mobileContact;
        data["childrenCount"] = this.childrenCount;
        return data;
    }
}

export interface IParentDto {
    parentId?: string;
    institutionId?: string;
    emailContact?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobileContact?: string | undefined;
    childrenCount?: number;
}

export class ParentDtoPaginatedDto implements IParentDtoPaginatedDto {
    data?: ParentDto[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: IParentDtoPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ParentDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): ParentDtoPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentDtoPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data;
    }
}

export interface IParentDtoPaginatedDto {
    data?: ParentDto[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class ParentFilterDto implements IParentFilterDto {
    accademicYearId?: string;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    studentId?: string;
    classrooms?: string[] | undefined;

    constructor(data?: IParentFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.institutionId = _data["institutionId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.studentId = _data["studentId"];
            if (Array.isArray(_data["classrooms"])) {
                this.classrooms = [] as any;
                for (let item of _data["classrooms"])
                    this.classrooms!.push(item);
            }
        }
    }

    static fromJS(data: any): ParentFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["institutionId"] = this.institutionId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["studentId"] = this.studentId;
        if (Array.isArray(this.classrooms)) {
            data["classrooms"] = [];
            for (let item of this.classrooms)
                data["classrooms"].push(item);
        }
        return data;
    }
}

export interface IParentFilterDto {
    accademicYearId?: string;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    studentId?: string;
    classrooms?: string[] | undefined;
}

export class ParentStudent implements IParentStudent {
    parentId?: string;
    studentId?: string;
    parent?: Parent;
    student?: Student;

    constructor(data?: IParentStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.studentId = _data["studentId"];
            this.parent = _data["parent"] ? Parent.fromJS(_data["parent"]) : undefined as any;
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParentStudent {
        data = typeof data === 'object' ? data : {};
        let result = new ParentStudent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["studentId"] = this.studentId;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["student"] = this.student ? this.student.toJSON() : undefined as any;
        return data;
    }
}

export interface IParentStudent {
    parentId?: string;
    studentId?: string;
    parent?: Parent;
    student?: Student;
}

export class Payment implements IPayment {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    accademicYear?: AccademicYear;
    accademicYearId?: string;
    comment?: string | undefined;
    date?: Date;
    institutionId?: string;
    paidBy?: string | undefined;
    paymentId?: string;
    paymentNumber?: string | undefined;
    paymentTerm?: PaymentTermType;
    verified?: boolean;
    succeded?: boolean;
    studentPayments?: StudentPayment[] | undefined;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.accademicYear = _data["accademicYear"] ? AccademicYear.fromJS(_data["accademicYear"]) : undefined as any;
            this.accademicYearId = _data["accademicYearId"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.institutionId = _data["institutionId"];
            this.paidBy = _data["paidBy"];
            this.paymentId = _data["paymentId"];
            this.paymentNumber = _data["paymentNumber"];
            this.paymentTerm = _data["paymentTerm"];
            this.verified = _data["verified"];
            this.succeded = _data["succeded"];
            if (Array.isArray(_data["studentPayments"])) {
                this.studentPayments = [] as any;
                for (let item of _data["studentPayments"])
                    this.studentPayments!.push(StudentPayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["accademicYear"] = this.accademicYear ? this.accademicYear.toJSON() : undefined as any;
        data["accademicYearId"] = this.accademicYearId;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["institutionId"] = this.institutionId;
        data["paidBy"] = this.paidBy;
        data["paymentId"] = this.paymentId;
        data["paymentNumber"] = this.paymentNumber;
        data["paymentTerm"] = this.paymentTerm;
        data["verified"] = this.verified;
        data["succeded"] = this.succeded;
        if (Array.isArray(this.studentPayments)) {
            data["studentPayments"] = [];
            for (let item of this.studentPayments)
                data["studentPayments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPayment {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    accademicYear?: AccademicYear;
    accademicYearId?: string;
    comment?: string | undefined;
    date?: Date;
    institutionId?: string;
    paidBy?: string | undefined;
    paymentId?: string;
    paymentNumber?: string | undefined;
    paymentTerm?: PaymentTermType;
    verified?: boolean;
    succeded?: boolean;
    studentPayments?: StudentPayment[] | undefined;
}

export class PaymentDto implements IPaymentDto {
    accademicYearId?: string;
    comment?: string | undefined;
    date?: Date;
    institutionId?: string;
    paidBy?: string | undefined;
    paymentId?: string;
    paymentNumber?: string | undefined;
    paymentTerm?: PaymentTermType;
    studentPayments?: StudentPaymentDto[] | undefined;
    totalAmount?: number;
    creationDate?: Date;
    verified?: boolean;
    succeded?: boolean;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.institutionId = _data["institutionId"];
            this.paidBy = _data["paidBy"];
            this.paymentId = _data["paymentId"];
            this.paymentNumber = _data["paymentNumber"];
            this.paymentTerm = _data["paymentTerm"];
            if (Array.isArray(_data["studentPayments"])) {
                this.studentPayments = [] as any;
                for (let item of _data["studentPayments"])
                    this.studentPayments!.push(StudentPaymentDto.fromJS(item));
            }
            this.totalAmount = _data["totalAmount"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.verified = _data["verified"];
            this.succeded = _data["succeded"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["institutionId"] = this.institutionId;
        data["paidBy"] = this.paidBy;
        data["paymentId"] = this.paymentId;
        data["paymentNumber"] = this.paymentNumber;
        data["paymentTerm"] = this.paymentTerm;
        if (Array.isArray(this.studentPayments)) {
            data["studentPayments"] = [];
            for (let item of this.studentPayments)
                data["studentPayments"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalAmount"] = this.totalAmount;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["verified"] = this.verified;
        data["succeded"] = this.succeded;
        return data;
    }
}

export interface IPaymentDto {
    accademicYearId?: string;
    comment?: string | undefined;
    date?: Date;
    institutionId?: string;
    paidBy?: string | undefined;
    paymentId?: string;
    paymentNumber?: string | undefined;
    paymentTerm?: PaymentTermType;
    studentPayments?: StudentPaymentDto[] | undefined;
    totalAmount?: number;
    creationDate?: Date;
    verified?: boolean;
    succeded?: boolean;
}

export class PaymentDtoAmountPaginatedDto implements IPaymentDtoAmountPaginatedDto {
    data?: PaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;
    totalAmount?: number;

    constructor(data?: IPaymentDtoAmountPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PaymentDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): PaymentDtoAmountPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDtoAmountPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IPaymentDtoAmountPaginatedDto {
    data?: PaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;
    totalAmount?: number;
}

export class PaymentFilterDto implements IPaymentFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    fromAmount?: number | undefined;
    toAmount?: number | undefined;

    constructor(data?: IPaymentFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.institutionId = _data["institutionId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
        }
    }

    static fromJS(data: any): PaymentFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["institutionId"] = this.institutionId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        return data;
    }
}

export interface IPaymentFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    fromAmount?: number | undefined;
    toAmount?: number | undefined;
}

export class PaymentStatisticDto implements IPaymentStatisticDto {
    date?: Date;
    amount?: number;

    constructor(data?: IPaymentStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PaymentStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPaymentStatisticDto {
    date?: Date;
    amount?: number;
}

export enum PaymentTermType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class PeriodReportingDto implements IPeriodReportingDto {
    activeStudents!: number;
    activeTransport!: number;
    activeChildcare!: number;
    activeCanteen!: number;
    fromDate!: Date;
    toDate!: Date;
    payments!: StudentPaymentDto[];
    expenses!: ExpenseDto[];

    constructor(data?: IPeriodReportingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.payments = [];
            this.expenses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeStudents = _data["activeStudents"];
            this.activeTransport = _data["activeTransport"];
            this.activeChildcare = _data["activeChildcare"];
            this.activeCanteen = _data["activeCanteen"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(StudentPaymentDto.fromJS(item));
            }
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(ExpenseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PeriodReportingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodReportingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStudents"] = this.activeStudents;
        data["activeTransport"] = this.activeTransport;
        data["activeChildcare"] = this.activeChildcare;
        data["activeCanteen"] = this.activeCanteen;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPeriodReportingDto {
    activeStudents: number;
    activeTransport: number;
    activeChildcare: number;
    activeCanteen: number;
    fromDate: Date;
    toDate: Date;
    payments: StudentPaymentDto[];
    expenses: ExpenseDto[];
}

export class PieChartDto implements IPieChartDto {
    others?: DoubleChartDto[] | undefined;
    top?: DoubleChartDto[] | undefined;
    readonly othersValue?: number;
    readonly topValue?: number;

    constructor(data?: IPieChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["others"])) {
                this.others = [] as any;
                for (let item of _data["others"])
                    this.others!.push(DoubleChartDto.fromJS(item));
            }
            if (Array.isArray(_data["top"])) {
                this.top = [] as any;
                for (let item of _data["top"])
                    this.top!.push(DoubleChartDto.fromJS(item));
            }
            (this as any).othersValue = _data["othersValue"];
            (this as any).topValue = _data["topValue"];
        }
    }

    static fromJS(data: any): PieChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.others)) {
            data["others"] = [];
            for (let item of this.others)
                data["others"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.top)) {
            data["top"] = [];
            for (let item of this.top)
                data["top"].push(item ? item.toJSON() : undefined as any);
        }
        data["othersValue"] = this.othersValue;
        data["topValue"] = this.topValue;
        return data;
    }
}

export interface IPieChartDto {
    others?: DoubleChartDto[] | undefined;
    top?: DoubleChartDto[] | undefined;
    othersValue?: number;
    topValue?: number;
}

export class PublicAccademicYearDto implements IPublicAccademicYearDto {
    canteenFees?: number;
    childCareFees?: number;
    endDate?: Date;
    hasCanteen?: boolean;
    hasChildCare?: boolean;
    hasTransport?: boolean;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    transportFees?: number;

    constructor(data?: IPublicAccademicYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canteenFees = _data["canteenFees"];
            this.childCareFees = _data["childCareFees"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.hasCanteen = _data["hasCanteen"];
            this.hasChildCare = _data["hasChildCare"];
            this.hasTransport = _data["hasTransport"];
            this.inscriptionFees = _data["inscriptionFees"];
            this.monthlyFees = _data["monthlyFees"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.transportFees = _data["transportFees"];
        }
    }

    static fromJS(data: any): PublicAccademicYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicAccademicYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canteenFees"] = this.canteenFees;
        data["childCareFees"] = this.childCareFees;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["hasCanteen"] = this.hasCanteen;
        data["hasChildCare"] = this.hasChildCare;
        data["hasTransport"] = this.hasTransport;
        data["inscriptionFees"] = this.inscriptionFees;
        data["monthlyFees"] = this.monthlyFees;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["transportFees"] = this.transportFees;
        return data;
    }
}

export interface IPublicAccademicYearDto {
    canteenFees?: number;
    childCareFees?: number;
    endDate?: Date;
    hasCanteen?: boolean;
    hasChildCare?: boolean;
    hasTransport?: boolean;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    transportFees?: number;
}

export class PublicInstitutionDto implements IPublicInstitutionDto {
    address?: string | undefined;
    city?: string | undefined;
    emailContact?: string | undefined;
    logo?: string | undefined;
    name?: string | undefined;
    printReceiptNumber?: boolean;
    printReceiptQrCode?: boolean;
    receiptFormat?: string | undefined;
    receiptOrientation?: string | undefined;
    telephoneContact?: string | undefined;
    website?: string | undefined;

    constructor(data?: IPublicInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.emailContact = _data["emailContact"];
            this.logo = _data["logo"];
            this.name = _data["name"];
            this.printReceiptNumber = _data["printReceiptNumber"];
            this.printReceiptQrCode = _data["printReceiptQrCode"];
            this.receiptFormat = _data["receiptFormat"];
            this.receiptOrientation = _data["receiptOrientation"];
            this.telephoneContact = _data["telephoneContact"];
            this.website = _data["website"];
        }
    }

    static fromJS(data: any): PublicInstitutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicInstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["emailContact"] = this.emailContact;
        data["logo"] = this.logo;
        data["name"] = this.name;
        data["printReceiptNumber"] = this.printReceiptNumber;
        data["printReceiptQrCode"] = this.printReceiptQrCode;
        data["receiptFormat"] = this.receiptFormat;
        data["receiptOrientation"] = this.receiptOrientation;
        data["telephoneContact"] = this.telephoneContact;
        data["website"] = this.website;
        return data;
    }
}

export interface IPublicInstitutionDto {
    address?: string | undefined;
    city?: string | undefined;
    emailContact?: string | undefined;
    logo?: string | undefined;
    name?: string | undefined;
    printReceiptNumber?: boolean;
    printReceiptQrCode?: boolean;
    receiptFormat?: string | undefined;
    receiptOrientation?: string | undefined;
    telephoneContact?: string | undefined;
    website?: string | undefined;
}

export class PublicPaymentDto implements IPublicPaymentDto {
    comment?: string | undefined;
    creationDate?: Date;
    date?: Date;
    paidBy?: string | undefined;
    paymentNumber?: string | undefined;
    paymentTerm?: PaymentTermType;
    studentPayments?: PublicStudentPaymentDto[] | undefined;
    succeded?: boolean;
    totalAmount?: number;
    verified?: boolean;

    constructor(data?: IPublicPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.paidBy = _data["paidBy"];
            this.paymentNumber = _data["paymentNumber"];
            this.paymentTerm = _data["paymentTerm"];
            if (Array.isArray(_data["studentPayments"])) {
                this.studentPayments = [] as any;
                for (let item of _data["studentPayments"])
                    this.studentPayments!.push(PublicStudentPaymentDto.fromJS(item));
            }
            this.succeded = _data["succeded"];
            this.totalAmount = _data["totalAmount"];
            this.verified = _data["verified"];
        }
    }

    static fromJS(data: any): PublicPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["paidBy"] = this.paidBy;
        data["paymentNumber"] = this.paymentNumber;
        data["paymentTerm"] = this.paymentTerm;
        if (Array.isArray(this.studentPayments)) {
            data["studentPayments"] = [];
            for (let item of this.studentPayments)
                data["studentPayments"].push(item ? item.toJSON() : undefined as any);
        }
        data["succeded"] = this.succeded;
        data["totalAmount"] = this.totalAmount;
        data["verified"] = this.verified;
        return data;
    }
}

export interface IPublicPaymentDto {
    comment?: string | undefined;
    creationDate?: Date;
    date?: Date;
    paidBy?: string | undefined;
    paymentNumber?: string | undefined;
    paymentTerm?: PaymentTermType;
    studentPayments?: PublicStudentPaymentDto[] | undefined;
    succeded?: boolean;
    totalAmount?: number;
    verified?: boolean;
}

export class PublicPaymentResultDto implements IPublicPaymentResultDto {
    payment?: PublicPaymentDto;
    institution?: PublicInstitutionDto;
    accademicYear?: PublicAccademicYearDto;

    constructor(data?: IPublicPaymentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payment = _data["payment"] ? PublicPaymentDto.fromJS(_data["payment"]) : undefined as any;
            this.institution = _data["institution"] ? PublicInstitutionDto.fromJS(_data["institution"]) : undefined as any;
            this.accademicYear = _data["accademicYear"] ? PublicAccademicYearDto.fromJS(_data["accademicYear"]) : undefined as any;
        }
    }

    static fromJS(data: any): PublicPaymentResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPaymentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : undefined as any;
        data["institution"] = this.institution ? this.institution.toJSON() : undefined as any;
        data["accademicYear"] = this.accademicYear ? this.accademicYear.toJSON() : undefined as any;
        return data;
    }
}

export interface IPublicPaymentResultDto {
    payment?: PublicPaymentDto;
    institution?: PublicInstitutionDto;
    accademicYear?: PublicAccademicYearDto;
}

export class PublicStudentPaymentDto implements IPublicStudentPaymentDto {
    canteenAmount!: number;
    childCareAmount!: number;
    classroomEnum?: number;
    classroomName?: string | undefined;
    comment?: string | undefined;
    date!: Date;
    educationEnum?: number;
    educationName?: string | undefined;
    inscriptionAmount!: number;
    paidBy?: string | undefined;
    paymentTermId!: number;
    schoolAmount!: number;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    totalAmount!: number;
    transportAmount!: number;
    situation?: StudentMonthlyPaymentSituationDto[] | undefined;

    constructor(data?: IPublicStudentPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canteenAmount = _data["canteenAmount"];
            this.childCareAmount = _data["childCareAmount"];
            this.classroomEnum = _data["classroomEnum"];
            this.classroomName = _data["classroomName"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.educationEnum = _data["educationEnum"];
            this.educationName = _data["educationName"];
            this.inscriptionAmount = _data["inscriptionAmount"];
            this.paidBy = _data["paidBy"];
            this.paymentTermId = _data["paymentTermId"];
            this.schoolAmount = _data["schoolAmount"];
            this.studentFirstName = _data["studentFirstName"];
            this.studentLastName = _data["studentLastName"];
            this.totalAmount = _data["totalAmount"];
            this.transportAmount = _data["transportAmount"];
            if (Array.isArray(_data["situation"])) {
                this.situation = [] as any;
                for (let item of _data["situation"])
                    this.situation!.push(StudentMonthlyPaymentSituationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicStudentPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicStudentPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canteenAmount"] = this.canteenAmount;
        data["childCareAmount"] = this.childCareAmount;
        data["classroomEnum"] = this.classroomEnum;
        data["classroomName"] = this.classroomName;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["educationEnum"] = this.educationEnum;
        data["educationName"] = this.educationName;
        data["inscriptionAmount"] = this.inscriptionAmount;
        data["paidBy"] = this.paidBy;
        data["paymentTermId"] = this.paymentTermId;
        data["schoolAmount"] = this.schoolAmount;
        data["studentFirstName"] = this.studentFirstName;
        data["studentLastName"] = this.studentLastName;
        data["totalAmount"] = this.totalAmount;
        data["transportAmount"] = this.transportAmount;
        if (Array.isArray(this.situation)) {
            data["situation"] = [];
            for (let item of this.situation)
                data["situation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPublicStudentPaymentDto {
    canteenAmount: number;
    childCareAmount: number;
    classroomEnum?: number;
    classroomName?: string | undefined;
    comment?: string | undefined;
    date: Date;
    educationEnum?: number;
    educationName?: string | undefined;
    inscriptionAmount: number;
    paidBy?: string | undefined;
    paymentTermId: number;
    schoolAmount: number;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    totalAmount: number;
    transportAmount: number;
    situation?: StudentMonthlyPaymentSituationDto[] | undefined;
}

export class Service implements IService {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    serviceId?: string;
    description?: string | undefined;
    name?: string | undefined;
    enum?: ServiceType;
    inscriptions?: Inscription[] | undefined;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.serviceId = _data["serviceId"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.enum = _data["enum"];
            if (Array.isArray(_data["inscriptions"])) {
                this.inscriptions = [] as any;
                for (let item of _data["inscriptions"])
                    this.inscriptions!.push(Inscription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["serviceId"] = this.serviceId;
        data["description"] = this.description;
        data["name"] = this.name;
        data["enum"] = this.enum;
        if (Array.isArray(this.inscriptions)) {
            data["inscriptions"] = [];
            for (let item of this.inscriptions)
                data["inscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IService {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    serviceId?: string;
    description?: string | undefined;
    name?: string | undefined;
    enum?: ServiceType;
    inscriptions?: Inscription[] | undefined;
}

export class ServiceDto implements IServiceDto {
    description?: string | undefined;
    enum?: ServiceType;
    name?: string | undefined;
    serviceId?: string;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.enum = _data["enum"];
            this.name = _data["name"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["enum"] = this.enum;
        data["name"] = this.name;
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface IServiceDto {
    description?: string | undefined;
    enum?: ServiceType;
    name?: string | undefined;
    serviceId?: string;
}

export enum ServiceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SmsCampaign implements ISmsCampaign {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    smsCampaignId?: string;
    communicationTypeId?: number;
    smsSubscriptionId?: string;
    smsSent?: number;
    smsSuccess?: number;
    smsFaild?: number;
    date?: Date;
    communicationType?: CommunicationType;
    smsSubscription?: SmsSubscription;
    smsSentNavigation?: SmsSent[] | undefined;

    constructor(data?: ISmsCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.smsCampaignId = _data["smsCampaignId"];
            this.communicationTypeId = _data["communicationTypeId"];
            this.smsSubscriptionId = _data["smsSubscriptionId"];
            this.smsSent = _data["smsSent"];
            this.smsSuccess = _data["smsSuccess"];
            this.smsFaild = _data["smsFaild"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.communicationType = _data["communicationType"] ? CommunicationType.fromJS(_data["communicationType"]) : undefined as any;
            this.smsSubscription = _data["smsSubscription"] ? SmsSubscription.fromJS(_data["smsSubscription"]) : undefined as any;
            if (Array.isArray(_data["smsSentNavigation"])) {
                this.smsSentNavigation = [] as any;
                for (let item of _data["smsSentNavigation"])
                    this.smsSentNavigation!.push(SmsSent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SmsCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new SmsCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["smsCampaignId"] = this.smsCampaignId;
        data["communicationTypeId"] = this.communicationTypeId;
        data["smsSubscriptionId"] = this.smsSubscriptionId;
        data["smsSent"] = this.smsSent;
        data["smsSuccess"] = this.smsSuccess;
        data["smsFaild"] = this.smsFaild;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["communicationType"] = this.communicationType ? this.communicationType.toJSON() : undefined as any;
        data["smsSubscription"] = this.smsSubscription ? this.smsSubscription.toJSON() : undefined as any;
        if (Array.isArray(this.smsSentNavigation)) {
            data["smsSentNavigation"] = [];
            for (let item of this.smsSentNavigation)
                data["smsSentNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISmsCampaign {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    smsCampaignId?: string;
    communicationTypeId?: number;
    smsSubscriptionId?: string;
    smsSent?: number;
    smsSuccess?: number;
    smsFaild?: number;
    date?: Date;
    communicationType?: CommunicationType;
    smsSubscription?: SmsSubscription;
    smsSentNavigation?: SmsSent[] | undefined;
}

export class SmsSent implements ISmsSent {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    smsSentId?: string;
    smsCampaignId?: string;
    parentId?: string | undefined;
    message?: string | undefined;
    recipient?: string | undefined;
    isSuccess?: boolean;
    reportMessage?: string | undefined;
    parent?: Parent;
    smsCampaign?: SmsCampaign;

    constructor(data?: ISmsSent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.smsSentId = _data["smsSentId"];
            this.smsCampaignId = _data["smsCampaignId"];
            this.parentId = _data["parentId"];
            this.message = _data["message"];
            this.recipient = _data["recipient"];
            this.isSuccess = _data["isSuccess"];
            this.reportMessage = _data["reportMessage"];
            this.parent = _data["parent"] ? Parent.fromJS(_data["parent"]) : undefined as any;
            this.smsCampaign = _data["smsCampaign"] ? SmsCampaign.fromJS(_data["smsCampaign"]) : undefined as any;
        }
    }

    static fromJS(data: any): SmsSent {
        data = typeof data === 'object' ? data : {};
        let result = new SmsSent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["smsSentId"] = this.smsSentId;
        data["smsCampaignId"] = this.smsCampaignId;
        data["parentId"] = this.parentId;
        data["message"] = this.message;
        data["recipient"] = this.recipient;
        data["isSuccess"] = this.isSuccess;
        data["reportMessage"] = this.reportMessage;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["smsCampaign"] = this.smsCampaign ? this.smsCampaign.toJSON() : undefined as any;
        return data;
    }
}

export interface ISmsSent {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    smsSentId?: string;
    smsCampaignId?: string;
    parentId?: string | undefined;
    message?: string | undefined;
    recipient?: string | undefined;
    isSuccess?: boolean;
    reportMessage?: string | undefined;
    parent?: Parent;
    smsCampaign?: SmsCampaign;
}

export class SmsSubscription implements ISmsSubscription {
    smsSubscriptionId?: string;
    institutionId?: string;
    balance?: number;
    alias?: string | undefined;
    smsCampaigns?: SmsCampaign[] | undefined;

    constructor(data?: ISmsSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsSubscriptionId = _data["smsSubscriptionId"];
            this.institutionId = _data["institutionId"];
            this.balance = _data["balance"];
            this.alias = _data["alias"];
            if (Array.isArray(_data["smsCampaigns"])) {
                this.smsCampaigns = [] as any;
                for (let item of _data["smsCampaigns"])
                    this.smsCampaigns!.push(SmsCampaign.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SmsSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new SmsSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsSubscriptionId"] = this.smsSubscriptionId;
        data["institutionId"] = this.institutionId;
        data["balance"] = this.balance;
        data["alias"] = this.alias;
        if (Array.isArray(this.smsCampaigns)) {
            data["smsCampaigns"] = [];
            for (let item of this.smsCampaigns)
                data["smsCampaigns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISmsSubscription {
    smsSubscriptionId?: string;
    institutionId?: string;
    balance?: number;
    alias?: string | undefined;
    smsCampaigns?: SmsCampaign[] | undefined;
}

export enum SortOrderType {
    _0 = 0,
    _1 = 1,
}

export class StatisticFilterDto implements IStatisticFilterDto {
    startDate?: Date;
    endDate?: Date;
    statisticPeriod?: StatisticPeriod;
    accademicYearId?: string;

    constructor(data?: IStatisticFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.statisticPeriod = _data["statisticPeriod"];
            this.accademicYearId = _data["accademicYearId"];
        }
    }

    static fromJS(data: any): StatisticFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["statisticPeriod"] = this.statisticPeriod;
        data["accademicYearId"] = this.accademicYearId;
        return data;
    }
}

export interface IStatisticFilterDto {
    startDate?: Date;
    endDate?: Date;
    statisticPeriod?: StatisticPeriod;
    accademicYearId?: string;
}

export enum StatisticPeriod {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Student implements IStudent {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    studentId?: string;
    dateOfBirth?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    institutionId?: string;
    studentPaths?: StudentPath[] | undefined;
    parents?: ParentStudent[] | undefined;

    constructor(data?: IStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.studentId = _data["studentId"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : undefined as any;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.institutionId = _data["institutionId"];
            if (Array.isArray(_data["studentPaths"])) {
                this.studentPaths = [] as any;
                for (let item of _data["studentPaths"])
                    this.studentPaths!.push(StudentPath.fromJS(item));
            }
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(ParentStudent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Student {
        data = typeof data === 'object' ? data : {};
        let result = new Student();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["studentId"] = this.studentId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["institutionId"] = this.institutionId;
        if (Array.isArray(this.studentPaths)) {
            data["studentPaths"] = [];
            for (let item of this.studentPaths)
                data["studentPaths"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStudent {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    studentId?: string;
    dateOfBirth?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    institutionId?: string;
    studentPaths?: StudentPath[] | undefined;
    parents?: ParentStudent[] | undefined;
}

export class StudentCreationDto implements IStudentCreationDto {
    institutionId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    startDate?: Date;
    endDate?: Date;
    accademicYearId?: string;
    classroomId?: string;
    inscriptionFees?: number;
    monthlyFees?: number;
    hasTransport?: boolean;
    transportFees?: number;
    hasChildCare?: boolean;
    childCareFees?: number;
    hasCanteen?: boolean;
    canteenFees?: number;

    constructor(data?: IStudentCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.institutionId = _data["institutionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.accademicYearId = _data["accademicYearId"];
            this.classroomId = _data["classroomId"];
            this.inscriptionFees = _data["inscriptionFees"];
            this.monthlyFees = _data["monthlyFees"];
            this.hasTransport = _data["hasTransport"];
            this.transportFees = _data["transportFees"];
            this.hasChildCare = _data["hasChildCare"];
            this.childCareFees = _data["childCareFees"];
            this.hasCanteen = _data["hasCanteen"];
            this.canteenFees = _data["canteenFees"];
        }
    }

    static fromJS(data: any): StudentCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["institutionId"] = this.institutionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["accademicYearId"] = this.accademicYearId;
        data["classroomId"] = this.classroomId;
        data["inscriptionFees"] = this.inscriptionFees;
        data["monthlyFees"] = this.monthlyFees;
        data["hasTransport"] = this.hasTransport;
        data["transportFees"] = this.transportFees;
        data["hasChildCare"] = this.hasChildCare;
        data["childCareFees"] = this.childCareFees;
        data["hasCanteen"] = this.hasCanteen;
        data["canteenFees"] = this.canteenFees;
        return data;
    }
}

export interface IStudentCreationDto {
    institutionId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    startDate?: Date;
    endDate?: Date;
    accademicYearId?: string;
    classroomId?: string;
    inscriptionFees?: number;
    monthlyFees?: number;
    hasTransport?: boolean;
    transportFees?: number;
    hasChildCare?: boolean;
    childCareFees?: number;
    hasCanteen?: boolean;
    canteenFees?: number;
}

export class StudentExamDto implements IStudentExamDto {
    examId?: string;
    examName?: string | undefined;
    examDate?: Date;
    teacherId?: string;
    teacherName?: string | undefined;
    isGraded?: boolean;
    examGradeId?: string | undefined;
    gradeValue?: number | undefined;
    gradeText?: string | undefined;
    subjectName?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IStudentExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.examName = _data["examName"];
            this.examDate = _data["examDate"] ? new Date(_data["examDate"].toString()) : undefined as any;
            this.teacherId = _data["teacherId"];
            this.teacherName = _data["teacherName"];
            this.isGraded = _data["isGraded"];
            this.examGradeId = _data["examGradeId"];
            this.gradeValue = _data["gradeValue"];
            this.gradeText = _data["gradeText"];
            this.subjectName = _data["subjectName"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): StudentExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["examName"] = this.examName;
        data["examDate"] = this.examDate ? this.examDate.toISOString() : undefined as any;
        data["teacherId"] = this.teacherId;
        data["teacherName"] = this.teacherName;
        data["isGraded"] = this.isGraded;
        data["examGradeId"] = this.examGradeId;
        data["gradeValue"] = this.gradeValue;
        data["gradeText"] = this.gradeText;
        data["subjectName"] = this.subjectName;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IStudentExamDto {
    examId?: string;
    examName?: string | undefined;
    examDate?: Date;
    teacherId?: string;
    teacherName?: string | undefined;
    isGraded?: boolean;
    examGradeId?: string | undefined;
    gradeValue?: number | undefined;
    gradeText?: string | undefined;
    subjectName?: string | undefined;
    comment?: string | undefined;
}

export class StudentFilterDto implements IStudentFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    classrooms?: string[] | undefined;
    ignoreIds?: string[] | undefined;
    ignoreStudentPathIds?: string[] | undefined;
    sortRole?: number;
    ignoreAccademicYearIds?: string[] | undefined;

    constructor(data?: IStudentFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.institutionId = _data["institutionId"];
            this.filter = _data["filter"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["classrooms"])) {
                this.classrooms = [] as any;
                for (let item of _data["classrooms"])
                    this.classrooms!.push(item);
            }
            if (Array.isArray(_data["ignoreIds"])) {
                this.ignoreIds = [] as any;
                for (let item of _data["ignoreIds"])
                    this.ignoreIds!.push(item);
            }
            if (Array.isArray(_data["ignoreStudentPathIds"])) {
                this.ignoreStudentPathIds = [] as any;
                for (let item of _data["ignoreStudentPathIds"])
                    this.ignoreStudentPathIds!.push(item);
            }
            this.sortRole = _data["sortRole"];
            if (Array.isArray(_data["ignoreAccademicYearIds"])) {
                this.ignoreAccademicYearIds = [] as any;
                for (let item of _data["ignoreAccademicYearIds"])
                    this.ignoreAccademicYearIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StudentFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["institutionId"] = this.institutionId;
        data["filter"] = this.filter;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.classrooms)) {
            data["classrooms"] = [];
            for (let item of this.classrooms)
                data["classrooms"].push(item);
        }
        if (Array.isArray(this.ignoreIds)) {
            data["ignoreIds"] = [];
            for (let item of this.ignoreIds)
                data["ignoreIds"].push(item);
        }
        if (Array.isArray(this.ignoreStudentPathIds)) {
            data["ignoreStudentPathIds"] = [];
            for (let item of this.ignoreStudentPathIds)
                data["ignoreStudentPathIds"].push(item);
        }
        data["sortRole"] = this.sortRole;
        if (Array.isArray(this.ignoreAccademicYearIds)) {
            data["ignoreAccademicYearIds"] = [];
            for (let item of this.ignoreAccademicYearIds)
                data["ignoreAccademicYearIds"].push(item);
        }
        return data;
    }
}

export interface IStudentFilterDto {
    accademicYearId?: string | undefined;
    institutionId?: string;
    filter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrderType;
    classrooms?: string[] | undefined;
    ignoreIds?: string[] | undefined;
    ignoreStudentPathIds?: string[] | undefined;
    sortRole?: number;
    ignoreAccademicYearIds?: string[] | undefined;
}

export class StudentMonthlyPaymentSituationDto implements IStudentMonthlyPaymentSituationDto {
    inscriptionToPay!: number;
    isPaid!: boolean;
    month!: number;
    scolarshipToPay!: number;
    servicesToPay?: { [key: string]: number; } | undefined;
    totalPaid!: number;
    readonly totalToPay!: number;
    year!: number;

    constructor(data?: IStudentMonthlyPaymentSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inscriptionToPay = _data["inscriptionToPay"];
            this.isPaid = _data["isPaid"];
            this.month = _data["month"];
            this.scolarshipToPay = _data["scolarshipToPay"];
            if (_data["servicesToPay"]) {
                this.servicesToPay = {} as any;
                for (let key in _data["servicesToPay"]) {
                    if (_data["servicesToPay"].hasOwnProperty(key))
                        (this.servicesToPay as any)![key] = _data["servicesToPay"][key];
                }
            }
            this.totalPaid = _data["totalPaid"];
            (this as any).totalToPay = _data["totalToPay"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): StudentMonthlyPaymentSituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentMonthlyPaymentSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inscriptionToPay"] = this.inscriptionToPay;
        data["isPaid"] = this.isPaid;
        data["month"] = this.month;
        data["scolarshipToPay"] = this.scolarshipToPay;
        if (this.servicesToPay) {
            data["servicesToPay"] = {};
            for (let key in this.servicesToPay) {
                if (this.servicesToPay.hasOwnProperty(key))
                    (data["servicesToPay"] as any)[key] = (this.servicesToPay as any)[key];
            }
        }
        data["totalPaid"] = this.totalPaid;
        data["totalToPay"] = this.totalToPay;
        data["year"] = this.year;
        return data;
    }
}

export interface IStudentMonthlyPaymentSituationDto {
    inscriptionToPay: number;
    isPaid: boolean;
    month: number;
    scolarshipToPay: number;
    servicesToPay?: { [key: string]: number; } | undefined;
    totalPaid: number;
    totalToPay: number;
    year: number;
}

export class StudentPath implements IStudentPath {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    studentPathId?: string;
    studentId?: string;
    classroomId?: string;
    accademicYearId?: string;
    inscriptionFees?: number;
    startDate?: Date;
    endDate?: Date;
    monthlyFees?: number;
    accademicYear?: AccademicYear;
    classroom?: Classroom;
    student?: Student;
    inscriptions?: Inscription[] | undefined;
    studentPayments?: StudentPayment[] | undefined;
    examGrades?: ExamGrade[] | undefined;

    constructor(data?: IStudentPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.studentPathId = _data["studentPathId"];
            this.studentId = _data["studentId"];
            this.classroomId = _data["classroomId"];
            this.accademicYearId = _data["accademicYearId"];
            this.inscriptionFees = _data["inscriptionFees"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.monthlyFees = _data["monthlyFees"];
            this.accademicYear = _data["accademicYear"] ? AccademicYear.fromJS(_data["accademicYear"]) : undefined as any;
            this.classroom = _data["classroom"] ? Classroom.fromJS(_data["classroom"]) : undefined as any;
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : undefined as any;
            if (Array.isArray(_data["inscriptions"])) {
                this.inscriptions = [] as any;
                for (let item of _data["inscriptions"])
                    this.inscriptions!.push(Inscription.fromJS(item));
            }
            if (Array.isArray(_data["studentPayments"])) {
                this.studentPayments = [] as any;
                for (let item of _data["studentPayments"])
                    this.studentPayments!.push(StudentPayment.fromJS(item));
            }
            if (Array.isArray(_data["examGrades"])) {
                this.examGrades = [] as any;
                for (let item of _data["examGrades"])
                    this.examGrades!.push(ExamGrade.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentPath {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["studentPathId"] = this.studentPathId;
        data["studentId"] = this.studentId;
        data["classroomId"] = this.classroomId;
        data["accademicYearId"] = this.accademicYearId;
        data["inscriptionFees"] = this.inscriptionFees;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["monthlyFees"] = this.monthlyFees;
        data["accademicYear"] = this.accademicYear ? this.accademicYear.toJSON() : undefined as any;
        data["classroom"] = this.classroom ? this.classroom.toJSON() : undefined as any;
        data["student"] = this.student ? this.student.toJSON() : undefined as any;
        if (Array.isArray(this.inscriptions)) {
            data["inscriptions"] = [];
            for (let item of this.inscriptions)
                data["inscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.studentPayments)) {
            data["studentPayments"] = [];
            for (let item of this.studentPayments)
                data["studentPayments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.examGrades)) {
            data["examGrades"] = [];
            for (let item of this.examGrades)
                data["examGrades"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStudentPath {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    studentPathId?: string;
    studentId?: string;
    classroomId?: string;
    accademicYearId?: string;
    inscriptionFees?: number;
    startDate?: Date;
    endDate?: Date;
    monthlyFees?: number;
    accademicYear?: AccademicYear;
    classroom?: Classroom;
    student?: Student;
    inscriptions?: Inscription[] | undefined;
    studentPayments?: StudentPayment[] | undefined;
    examGrades?: ExamGrade[] | undefined;
}

export class StudentPathDto implements IStudentPathDto {
    accademicYearId?: string;
    classroomAcronym?: string | undefined;
    classroomId?: string;
    classroomName?: string | undefined;
    readonly cost?: number;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    studentId?: string;
    studentPathId?: string;
    institutionId?: string;

    constructor(data?: IStudentPathDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.classroomAcronym = _data["classroomAcronym"];
            this.classroomId = _data["classroomId"];
            this.classroomName = _data["classroomName"];
            (this as any).cost = _data["cost"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.inscriptionFees = _data["inscriptionFees"];
            this.monthlyFees = _data["monthlyFees"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.studentFirstName = _data["studentFirstName"];
            this.studentLastName = _data["studentLastName"];
            this.studentId = _data["studentId"];
            this.studentPathId = _data["studentPathId"];
            this.institutionId = _data["institutionId"];
        }
    }

    static fromJS(data: any): StudentPathDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPathDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["classroomAcronym"] = this.classroomAcronym;
        data["classroomId"] = this.classroomId;
        data["classroomName"] = this.classroomName;
        data["cost"] = this.cost;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["inscriptionFees"] = this.inscriptionFees;
        data["monthlyFees"] = this.monthlyFees;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["studentFirstName"] = this.studentFirstName;
        data["studentLastName"] = this.studentLastName;
        data["studentId"] = this.studentId;
        data["studentPathId"] = this.studentPathId;
        data["institutionId"] = this.institutionId;
        return data;
    }
}

export interface IStudentPathDto {
    accademicYearId?: string;
    classroomAcronym?: string | undefined;
    classroomId?: string;
    classroomName?: string | undefined;
    cost?: number;
    endDate?: Date;
    inscriptionFees?: number;
    monthlyFees?: number;
    startDate?: Date;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    studentId?: string;
    studentPathId?: string;
    institutionId?: string;
}

export class StudentPathUpdateDto implements IStudentPathUpdateDto {
    accademicYearId?: string;
    classroomId?: string;
    endDate?: Date;
    inscriptionFees?: number;
    institutionId?: string;
    monthlyFees?: number;
    startDate?: Date;
    studentId?: string;
    studentPathId?: string;

    constructor(data?: IStudentPathUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accademicYearId = _data["accademicYearId"];
            this.classroomId = _data["classroomId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.inscriptionFees = _data["inscriptionFees"];
            this.institutionId = _data["institutionId"];
            this.monthlyFees = _data["monthlyFees"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.studentId = _data["studentId"];
            this.studentPathId = _data["studentPathId"];
        }
    }

    static fromJS(data: any): StudentPathUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPathUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accademicYearId"] = this.accademicYearId;
        data["classroomId"] = this.classroomId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["inscriptionFees"] = this.inscriptionFees;
        data["institutionId"] = this.institutionId;
        data["monthlyFees"] = this.monthlyFees;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["studentId"] = this.studentId;
        data["studentPathId"] = this.studentPathId;
        return data;
    }
}

export interface IStudentPathUpdateDto {
    accademicYearId?: string;
    classroomId?: string;
    endDate?: Date;
    inscriptionFees?: number;
    institutionId?: string;
    monthlyFees?: number;
    startDate?: Date;
    studentId?: string;
    studentPathId?: string;
}

export class StudentPayment implements IStudentPayment {
    studentPaymentId?: string;
    totalAmount?: number;
    studentPathId?: string;
    comment?: string | undefined;
    paymentId?: string;
    inscriptionAmount?: number;
    schoolAmount?: number;
    transportAmount?: number;
    childCareAmount?: number;
    canteenAmount?: number;
    payment?: Payment;
    studentPath?: StudentPath;

    constructor(data?: IStudentPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentPaymentId = _data["studentPaymentId"];
            this.totalAmount = _data["totalAmount"];
            this.studentPathId = _data["studentPathId"];
            this.comment = _data["comment"];
            this.paymentId = _data["paymentId"];
            this.inscriptionAmount = _data["inscriptionAmount"];
            this.schoolAmount = _data["schoolAmount"];
            this.transportAmount = _data["transportAmount"];
            this.childCareAmount = _data["childCareAmount"];
            this.canteenAmount = _data["canteenAmount"];
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : undefined as any;
            this.studentPath = _data["studentPath"] ? StudentPath.fromJS(_data["studentPath"]) : undefined as any;
        }
    }

    static fromJS(data: any): StudentPayment {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPaymentId"] = this.studentPaymentId;
        data["totalAmount"] = this.totalAmount;
        data["studentPathId"] = this.studentPathId;
        data["comment"] = this.comment;
        data["paymentId"] = this.paymentId;
        data["inscriptionAmount"] = this.inscriptionAmount;
        data["schoolAmount"] = this.schoolAmount;
        data["transportAmount"] = this.transportAmount;
        data["childCareAmount"] = this.childCareAmount;
        data["canteenAmount"] = this.canteenAmount;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined as any;
        data["studentPath"] = this.studentPath ? this.studentPath.toJSON() : undefined as any;
        return data;
    }
}

export interface IStudentPayment {
    studentPaymentId?: string;
    totalAmount?: number;
    studentPathId?: string;
    comment?: string | undefined;
    paymentId?: string;
    inscriptionAmount?: number;
    schoolAmount?: number;
    transportAmount?: number;
    childCareAmount?: number;
    canteenAmount?: number;
    payment?: Payment;
    studentPath?: StudentPath;
}

export class StudentPaymentDto implements IStudentPaymentDto {
    childCareAmount!: number;
    comment?: string | undefined;
    date!: Date;
    inscriptionAmount!: number;
    paymentId!: string;
    schoolAmount!: number;
    studentPathId!: string;
    studentId!: string;
    studentPaymentId!: string;
    totalAmount!: number;
    transportAmount!: number;
    canteenAmount!: number;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    educationName?: string | undefined;
    classroomName?: string | undefined;
    paidBy?: string | undefined;
    institutionId!: string;
    classroomId!: string;
    classroomEnum?: number;
    educationEnum?: number;
    paymentTermId!: number;
    situation?: StudentMonthlyPaymentSituationDto[] | undefined;

    constructor(data?: IStudentPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.childCareAmount = _data["childCareAmount"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.inscriptionAmount = _data["inscriptionAmount"];
            this.paymentId = _data["paymentId"];
            this.schoolAmount = _data["schoolAmount"];
            this.studentPathId = _data["studentPathId"];
            this.studentId = _data["studentId"];
            this.studentPaymentId = _data["studentPaymentId"];
            this.totalAmount = _data["totalAmount"];
            this.transportAmount = _data["transportAmount"];
            this.canteenAmount = _data["canteenAmount"];
            this.studentFirstName = _data["studentFirstName"];
            this.studentLastName = _data["studentLastName"];
            this.educationName = _data["educationName"];
            this.classroomName = _data["classroomName"];
            this.paidBy = _data["paidBy"];
            this.institutionId = _data["institutionId"];
            this.classroomId = _data["classroomId"];
            this.classroomEnum = _data["classroomEnum"];
            this.educationEnum = _data["educationEnum"];
            this.paymentTermId = _data["paymentTermId"];
            if (Array.isArray(_data["situation"])) {
                this.situation = [] as any;
                for (let item of _data["situation"])
                    this.situation!.push(StudentMonthlyPaymentSituationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childCareAmount"] = this.childCareAmount;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["inscriptionAmount"] = this.inscriptionAmount;
        data["paymentId"] = this.paymentId;
        data["schoolAmount"] = this.schoolAmount;
        data["studentPathId"] = this.studentPathId;
        data["studentId"] = this.studentId;
        data["studentPaymentId"] = this.studentPaymentId;
        data["totalAmount"] = this.totalAmount;
        data["transportAmount"] = this.transportAmount;
        data["canteenAmount"] = this.canteenAmount;
        data["studentFirstName"] = this.studentFirstName;
        data["studentLastName"] = this.studentLastName;
        data["educationName"] = this.educationName;
        data["classroomName"] = this.classroomName;
        data["paidBy"] = this.paidBy;
        data["institutionId"] = this.institutionId;
        data["classroomId"] = this.classroomId;
        data["classroomEnum"] = this.classroomEnum;
        data["educationEnum"] = this.educationEnum;
        data["paymentTermId"] = this.paymentTermId;
        if (Array.isArray(this.situation)) {
            data["situation"] = [];
            for (let item of this.situation)
                data["situation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStudentPaymentDto {
    childCareAmount: number;
    comment?: string | undefined;
    date: Date;
    inscriptionAmount: number;
    paymentId: string;
    schoolAmount: number;
    studentPathId: string;
    studentId: string;
    studentPaymentId: string;
    totalAmount: number;
    transportAmount: number;
    canteenAmount: number;
    studentFirstName?: string | undefined;
    studentLastName?: string | undefined;
    educationName?: string | undefined;
    classroomName?: string | undefined;
    paidBy?: string | undefined;
    institutionId: string;
    classroomId: string;
    classroomEnum?: number;
    educationEnum?: number;
    paymentTermId: number;
    situation?: StudentMonthlyPaymentSituationDto[] | undefined;
}

export class StudentPaymentDtoAmountPaginatedDto implements IStudentPaymentDtoAmountPaginatedDto {
    data?: StudentPaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;
    totalAmount?: number;

    constructor(data?: IStudentPaymentDtoAmountPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentPaymentDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): StudentPaymentDtoAmountPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPaymentDtoAmountPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IStudentPaymentDtoAmountPaginatedDto {
    data?: StudentPaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;
    totalAmount?: number;
}

export class StudentPaymentDtoPaginatedDto implements IStudentPaymentDtoPaginatedDto {
    data?: StudentPaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: IStudentPaymentDtoPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentPaymentDto.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): StudentPaymentDtoPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPaymentDtoPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data;
    }
}

export interface IStudentPaymentDtoPaginatedDto {
    data?: StudentPaymentDto[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class StudentUpdateDto implements IStudentUpdateDto {
    studentId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    institutionId?: string;

    constructor(data?: IStudentUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : undefined as any;
            this.institutionId = _data["institutionId"];
        }
    }

    static fromJS(data: any): StudentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["institutionId"] = this.institutionId;
        return data;
    }
}

export interface IStudentUpdateDto {
    studentId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    institutionId?: string;
}

export class StudentView implements IStudentView {
    institutionId?: string;
    studentId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    classroomId?: string;
    classroomAcronym?: string | undefined;
    classroomName?: string | undefined;
    educationId?: string | undefined;
    educationName?: string | undefined;
    studentPathId?: string;
    studentPathStartDate?: Date;
    studentPathEndDate?: Date;
    accademicYearId?: string;
    accademicYearStartDate?: Date;
    accademicYearEndDate?: Date;
    totalServicesCost!: number;
    todayServicesCost!: number;
    totalScolarshipCost!: number;
    todayScolarshipCost!: number;
    totalReceivedPayments!: number;

    constructor(data?: IStudentView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.institutionId = _data["institutionId"];
            this.studentId = _data["studentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : undefined as any;
            this.classroomId = _data["classroomId"];
            this.classroomAcronym = _data["classroomAcronym"];
            this.classroomName = _data["classroomName"];
            this.educationId = _data["educationId"];
            this.educationName = _data["educationName"];
            this.studentPathId = _data["studentPathId"];
            this.studentPathStartDate = _data["studentPathStartDate"] ? new Date(_data["studentPathStartDate"].toString()) : undefined as any;
            this.studentPathEndDate = _data["studentPathEndDate"] ? new Date(_data["studentPathEndDate"].toString()) : undefined as any;
            this.accademicYearId = _data["accademicYearId"];
            this.accademicYearStartDate = _data["accademicYearStartDate"] ? new Date(_data["accademicYearStartDate"].toString()) : undefined as any;
            this.accademicYearEndDate = _data["accademicYearEndDate"] ? new Date(_data["accademicYearEndDate"].toString()) : undefined as any;
            this.totalServicesCost = _data["totalServicesCost"];
            this.todayServicesCost = _data["todayServicesCost"];
            this.totalScolarshipCost = _data["totalScolarshipCost"];
            this.todayScolarshipCost = _data["todayScolarshipCost"];
            this.totalReceivedPayments = _data["totalReceivedPayments"];
        }
    }

    static fromJS(data: any): StudentView {
        data = typeof data === 'object' ? data : {};
        let result = new StudentView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["institutionId"] = this.institutionId;
        data["studentId"] = this.studentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["classroomId"] = this.classroomId;
        data["classroomAcronym"] = this.classroomAcronym;
        data["classroomName"] = this.classroomName;
        data["educationId"] = this.educationId;
        data["educationName"] = this.educationName;
        data["studentPathId"] = this.studentPathId;
        data["studentPathStartDate"] = this.studentPathStartDate ? this.studentPathStartDate.toISOString() : undefined as any;
        data["studentPathEndDate"] = this.studentPathEndDate ? this.studentPathEndDate.toISOString() : undefined as any;
        data["accademicYearId"] = this.accademicYearId;
        data["accademicYearStartDate"] = this.accademicYearStartDate ? this.accademicYearStartDate.toISOString() : undefined as any;
        data["accademicYearEndDate"] = this.accademicYearEndDate ? this.accademicYearEndDate.toISOString() : undefined as any;
        data["totalServicesCost"] = this.totalServicesCost;
        data["todayServicesCost"] = this.todayServicesCost;
        data["totalScolarshipCost"] = this.totalScolarshipCost;
        data["todayScolarshipCost"] = this.todayScolarshipCost;
        data["totalReceivedPayments"] = this.totalReceivedPayments;
        return data;
    }
}

export interface IStudentView {
    institutionId?: string;
    studentId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    classroomId?: string;
    classroomAcronym?: string | undefined;
    classroomName?: string | undefined;
    educationId?: string | undefined;
    educationName?: string | undefined;
    studentPathId?: string;
    studentPathStartDate?: Date;
    studentPathEndDate?: Date;
    accademicYearId?: string;
    accademicYearStartDate?: Date;
    accademicYearEndDate?: Date;
    totalServicesCost: number;
    todayServicesCost: number;
    totalScolarshipCost: number;
    todayScolarshipCost: number;
    totalReceivedPayments: number;
}

export class StudentViewPaginatedDto implements IStudentViewPaginatedDto {
    data?: StudentView[] | undefined;
    pages?: number;
    totalElements?: number;

    constructor(data?: IStudentViewPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentView.fromJS(item));
            }
            this.pages = _data["pages"];
            this.totalElements = _data["totalElements"];
        }
    }

    static fromJS(data: any): StudentViewPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentViewPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["pages"] = this.pages;
        data["totalElements"] = this.totalElements;
        return data;
    }
}

export interface IStudentViewPaginatedDto {
    data?: StudentView[] | undefined;
    pages?: number;
    totalElements?: number;
}

export class Subject implements ISubject {
    subjectId?: string;
    name?: string | undefined;
    institutionId?: string;
    classSchedules?: ClassSchedule[] | undefined;
    examGrades?: ExamGrade[] | undefined;

    constructor(data?: ISubject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            this.name = _data["name"];
            this.institutionId = _data["institutionId"];
            if (Array.isArray(_data["classSchedules"])) {
                this.classSchedules = [] as any;
                for (let item of _data["classSchedules"])
                    this.classSchedules!.push(ClassSchedule.fromJS(item));
            }
            if (Array.isArray(_data["examGrades"])) {
                this.examGrades = [] as any;
                for (let item of _data["examGrades"])
                    this.examGrades!.push(ExamGrade.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Subject {
        data = typeof data === 'object' ? data : {};
        let result = new Subject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        data["name"] = this.name;
        data["institutionId"] = this.institutionId;
        if (Array.isArray(this.classSchedules)) {
            data["classSchedules"] = [];
            for (let item of this.classSchedules)
                data["classSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.examGrades)) {
            data["examGrades"] = [];
            for (let item of this.examGrades)
                data["examGrades"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubject {
    subjectId?: string;
    name?: string | undefined;
    institutionId?: string;
    classSchedules?: ClassSchedule[] | undefined;
    examGrades?: ExamGrade[] | undefined;
}

export class SubjectDto implements ISubjectDto {
    subjectId?: string;
    name?: string | undefined;
    institutionId?: string;

    constructor(data?: ISubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            this.name = _data["name"];
            this.institutionId = _data["institutionId"];
        }
    }

    static fromJS(data: any): SubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        data["name"] = this.name;
        data["institutionId"] = this.institutionId;
        return data;
    }
}

export interface ISubjectDto {
    subjectId?: string;
    name?: string | undefined;
    institutionId?: string;
}

export class Teacher implements ITeacher {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    teacherId?: string;
    applicationUserId?: string | undefined;
    institutionId?: string;
    applicationUser?: ApplicationUser;
    teacherClassrooms?: TeacherClassroom[] | undefined;
    classSchedules?: ClassSchedule[] | undefined;
    examGrades?: ExamGrade[] | undefined;
    exams?: Exam[] | undefined;

    constructor(data?: ITeacher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdByUserId = _data["createdByUserId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.deletedByUserId = _data["deletedByUserId"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : undefined as any;
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : undefined as any;
            this.teacherId = _data["teacherId"];
            this.applicationUserId = _data["applicationUserId"];
            this.institutionId = _data["institutionId"];
            this.applicationUser = _data["applicationUser"] ? ApplicationUser.fromJS(_data["applicationUser"]) : undefined as any;
            if (Array.isArray(_data["teacherClassrooms"])) {
                this.teacherClassrooms = [] as any;
                for (let item of _data["teacherClassrooms"])
                    this.teacherClassrooms!.push(TeacherClassroom.fromJS(item));
            }
            if (Array.isArray(_data["classSchedules"])) {
                this.classSchedules = [] as any;
                for (let item of _data["classSchedules"])
                    this.classSchedules!.push(ClassSchedule.fromJS(item));
            }
            if (Array.isArray(_data["examGrades"])) {
                this.examGrades = [] as any;
                for (let item of _data["examGrades"])
                    this.examGrades!.push(ExamGrade.fromJS(item));
            }
            if (Array.isArray(_data["exams"])) {
                this.exams = [] as any;
                for (let item of _data["exams"])
                    this.exams!.push(Exam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Teacher {
        data = typeof data === 'object' ? data : {};
        let result = new Teacher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByUserId"] = this.createdByUserId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["deletedByUserId"] = this.deletedByUserId;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : undefined as any;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["teacherId"] = this.teacherId;
        data["applicationUserId"] = this.applicationUserId;
        data["institutionId"] = this.institutionId;
        data["applicationUser"] = this.applicationUser ? this.applicationUser.toJSON() : undefined as any;
        if (Array.isArray(this.teacherClassrooms)) {
            data["teacherClassrooms"] = [];
            for (let item of this.teacherClassrooms)
                data["teacherClassrooms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classSchedules)) {
            data["classSchedules"] = [];
            for (let item of this.classSchedules)
                data["classSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.examGrades)) {
            data["examGrades"] = [];
            for (let item of this.examGrades)
                data["examGrades"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exams)) {
            data["exams"] = [];
            for (let item of this.exams)
                data["exams"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITeacher {
    createdByUserId?: string | undefined;
    creationDate?: Date;
    deletedByUserId?: string | undefined;
    deletionDate?: Date | undefined;
    createdByUser?: ApplicationUser;
    teacherId?: string;
    applicationUserId?: string | undefined;
    institutionId?: string;
    applicationUser?: ApplicationUser;
    teacherClassrooms?: TeacherClassroom[] | undefined;
    classSchedules?: ClassSchedule[] | undefined;
    examGrades?: ExamGrade[] | undefined;
    exams?: Exam[] | undefined;
}

export class TeacherClassroom implements ITeacherClassroom {
    teacherId?: string;
    classroomId?: string;
    accademicYearId?: string;
    teacher?: Teacher;
    classroom?: Classroom;
    accademicYear?: AccademicYear;

    constructor(data?: ITeacherClassroom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teacherId = _data["teacherId"];
            this.classroomId = _data["classroomId"];
            this.accademicYearId = _data["accademicYearId"];
            this.teacher = _data["teacher"] ? Teacher.fromJS(_data["teacher"]) : undefined as any;
            this.classroom = _data["classroom"] ? Classroom.fromJS(_data["classroom"]) : undefined as any;
            this.accademicYear = _data["accademicYear"] ? AccademicYear.fromJS(_data["accademicYear"]) : undefined as any;
        }
    }

    static fromJS(data: any): TeacherClassroom {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherClassroom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teacherId"] = this.teacherId;
        data["classroomId"] = this.classroomId;
        data["accademicYearId"] = this.accademicYearId;
        data["teacher"] = this.teacher ? this.teacher.toJSON() : undefined as any;
        data["classroom"] = this.classroom ? this.classroom.toJSON() : undefined as any;
        data["accademicYear"] = this.accademicYear ? this.accademicYear.toJSON() : undefined as any;
        return data;
    }
}

export interface ITeacherClassroom {
    teacherId?: string;
    classroomId?: string;
    accademicYearId?: string;
    teacher?: Teacher;
    classroom?: Classroom;
    accademicYear?: AccademicYear;
}

export class TeacherClassroomDto implements ITeacherClassroomDto {
    teacherId?: string;
    teacherName?: string | undefined;
    classroomId?: string;
    classroomName?: string | undefined;
    accademicYearId?: string;

    constructor(data?: ITeacherClassroomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teacherId = _data["teacherId"];
            this.teacherName = _data["teacherName"];
            this.classroomId = _data["classroomId"];
            this.classroomName = _data["classroomName"];
            this.accademicYearId = _data["accademicYearId"];
        }
    }

    static fromJS(data: any): TeacherClassroomDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherClassroomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teacherId"] = this.teacherId;
        data["teacherName"] = this.teacherName;
        data["classroomId"] = this.classroomId;
        data["classroomName"] = this.classroomName;
        data["accademicYearId"] = this.accademicYearId;
        return data;
    }
}

export interface ITeacherClassroomDto {
    teacherId?: string;
    teacherName?: string | undefined;
    classroomId?: string;
    classroomName?: string | undefined;
    accademicYearId?: string;
}

export class TeacherDto implements ITeacherDto {
    teacherId?: string;
    applicationUserId?: string | undefined;
    institutionId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;

    constructor(data?: ITeacherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teacherId = _data["teacherId"];
            this.applicationUserId = _data["applicationUserId"];
            this.institutionId = _data["institutionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TeacherDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teacherId"] = this.teacherId;
        data["applicationUserId"] = this.applicationUserId;
        data["institutionId"] = this.institutionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface ITeacherDto {
    teacherId?: string;
    applicationUserId?: string | undefined;
    institutionId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export class TimeSpan implements ITimeSpan {
    readonly ticks?: number;
    readonly days?: number;
    readonly hours?: number;
    readonly milliseconds?: number;
    readonly minutes?: number;
    readonly seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).ticks = _data["ticks"];
            (this as any).days = _data["days"];
            (this as any).hours = _data["hours"];
            (this as any).milliseconds = _data["milliseconds"];
            (this as any).minutes = _data["minutes"];
            (this as any).seconds = _data["seconds"];
            (this as any).totalDays = _data["totalDays"];
            (this as any).totalHours = _data["totalHours"];
            (this as any).totalMilliseconds = _data["totalMilliseconds"];
            (this as any).totalMinutes = _data["totalMinutes"];
            (this as any).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class UserDto implements IUserDto {
    email?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    email?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roles?: string[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}